window.timber = window.timber || {};
window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ VENDORS ================ */
/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function (a) { a.fn.equalHeights = function () { var b = 0, c = a(this); return c.each(function () { var c = a(this).innerHeight(); c > b && (b = c) }), c.css("height", b) }, a("[data-equal]").each(function () { var b = a(this), c = b.data("equal"); b.find(c).equalHeights() }) }(jQuery);

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function (a, b, c) { var d = window.matchMedia; "undefined" != typeof module && module.exports ? module.exports = c(d) : "function" == typeof define && define.amd ? define(function () { return b[a] = c(d) }) : b[a] = c(d) }("enquire", this, function (a) { "use strict"; function b(a, b) { var c, d = 0, e = a.length; for (d; e > d && (c = b(a[d], d), c !== !1); d++); } function c(a) { return "[object Array]" === Object.prototype.toString.apply(a) } function d(a) { return "function" == typeof a } function e(a) { this.options = a, !a.deferSetup && this.setup() } function f(b, c) { this.query = b, this.isUnconditional = c, this.handlers = [], this.mql = a(b); var d = this; this.listener = function (a) { d.mql = a, d.assess() }, this.mql.addListener(this.listener) } function g() { if (!a) throw new Error("matchMedia not present, legacy browsers require a polyfill"); this.queries = {}, this.browserIsIncapable = !a("only all").matches } return e.prototype = { setup: function () { this.options.setup && this.options.setup(), this.initialised = !0 }, on: function () { !this.initialised && this.setup(), this.options.match && this.options.match() }, off: function () { this.options.unmatch && this.options.unmatch() }, destroy: function () { this.options.destroy ? this.options.destroy() : this.off() }, equals: function (a) { return this.options === a || this.options.match === a } }, f.prototype = { addHandler: function (a) { var b = new e(a); this.handlers.push(b), this.matches() && b.on() }, removeHandler: function (a) { var c = this.handlers; b(c, function (b, d) { return b.equals(a) ? (b.destroy(), !c.splice(d, 1)) : void 0 }) }, matches: function () { return this.mql.matches || this.isUnconditional }, clear: function () { b(this.handlers, function (a) { a.destroy() }), this.mql.removeListener(this.listener), this.handlers.length = 0 }, assess: function () { var a = this.matches() ? "on" : "off"; b(this.handlers, function (b) { b[a]() }) } }, g.prototype = { register: function (a, e, g) { var h = this.queries, i = g && this.browserIsIncapable; return h[a] || (h[a] = new f(a, i)), d(e) && (e = { match: e }), c(e) || (e = [e]), b(e, function (b) { d(b) && (b = { match: b }), h[a].addHandler(b) }), this }, unregister: function (a, b) { var c = this.queries[a]; return c && (b ? c.removeHandler(b) : (c.clear(), delete this.queries[a])), this } }, new g });

/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
(function (a) { a.isScrollToFixed = function (b) { return !!a(b).data("ScrollToFixed") }; a.ScrollToFixed = function (d, i) { var l = this; l.$el = a(d); l.el = d; l.$el.data("ScrollToFixed", l); var c = false; var G = l.$el; var H; var E; var e; var y; var D = 0; var q = 0; var j = -1; var f = -1; var t = null; var z; var g; function u() { G.trigger("preUnfixed.ScrollToFixed"); k(); G.trigger("unfixed.ScrollToFixed"); f = -1; D = G.offset().top; q = G.offset().left; if (l.options.offsets) { q += (G.offset().left - G.position().left) } if (j == -1) { j = q } H = G.css("position"); c = true; if (l.options.bottom != -1) { G.trigger("preFixed.ScrollToFixed"); w(); G.trigger("fixed.ScrollToFixed") } } function n() { var I = l.options.limit; if (!I) { return 0 } if (typeof (I) === "function") { return I.apply(G) } return I } function p() { return H === "fixed" } function x() { return H === "absolute" } function h() { return !(p() || x()) } function w() { if (!p()) { t.css({ display: G.css("display"), width: G.outerWidth(true), height: G.outerHeight(true), "float": G.css("float") }); cssOptions = { "z-index": l.options.zIndex, position: "fixed", top: l.options.bottom == -1 ? s() : "", bottom: l.options.bottom == -1 ? "" : l.options.bottom, "margin-left": "0px" }; if (!l.options.dontSetWidth) { cssOptions.width = G.width() } G.css(cssOptions); G.addClass(l.options.baseClassName); if (l.options.className) { G.addClass(l.options.className) } H = "fixed" } } function b() { var J = n(); var I = q; if (l.options.removeOffsets) { I = ""; J = J - D } cssOptions = { position: "absolute", top: J, left: I, "margin-left": "0px", bottom: "" }; if (!l.options.dontSetWidth) { cssOptions.width = G.width() } G.css(cssOptions); H = "absolute" } function k() { if (!h()) { f = -1; t.css("display", "none"); G.css({ "z-index": y, width: "", position: E, left: "", top: e, "margin-left": "" }); G.removeClass("scroll-to-fixed-fixed"); if (l.options.className) { G.removeClass(l.options.className) } H = null } } function v(I) { if (I != f) { G.css("left", q - I); f = I } } function s() { var I = l.options.marginTop; if (!I) { return 0 } if (typeof (I) === "function") { return I.apply(G) } return I } function A() { if (!a.isScrollToFixed(G)) { return } var K = c; if (!c) { u() } else { if (h()) { D = G.offset().top; q = G.offset().left } } var I = a(window).scrollLeft(); var L = a(window).scrollTop(); var J = n(); if (l.options.minWidth && a(window).width() < l.options.minWidth) { if (!h() || !K) { o(); G.trigger("preUnfixed.ScrollToFixed"); k(); G.trigger("unfixed.ScrollToFixed") } } else { if (l.options.maxWidth && a(window).width() > l.options.maxWidth) { if (!h() || !K) { o(); G.trigger("preUnfixed.ScrollToFixed"); k(); G.trigger("unfixed.ScrollToFixed") } } else { if (l.options.bottom == -1) { if (J > 0 && L >= J - s()) { if (!x() || !K) { o(); G.trigger("preAbsolute.ScrollToFixed"); b(); G.trigger("unfixed.ScrollToFixed") } } else { if (L >= D - s()) { if (!p() || !K) { o(); G.trigger("preFixed.ScrollToFixed"); w(); f = -1; G.trigger("fixed.ScrollToFixed") } v(I) } else { if (!h() || !K) { o(); G.trigger("preUnfixed.ScrollToFixed"); k(); G.trigger("unfixed.ScrollToFixed") } } } } else { if (J > 0) { if (L + a(window).height() - G.outerHeight(true) >= J - (s() || -m())) { if (p()) { o(); G.trigger("preUnfixed.ScrollToFixed"); if (E === "absolute") { b() } else { k() } G.trigger("unfixed.ScrollToFixed") } } else { if (!p()) { o(); G.trigger("preFixed.ScrollToFixed"); w() } v(I); G.trigger("fixed.ScrollToFixed") } } else { v(I) } } } } } function m() { if (!l.options.bottom) { return 0 } return l.options.bottom } function o() { var I = G.css("position"); if (I == "absolute") { G.trigger("postAbsolute.ScrollToFixed") } else { if (I == "fixed") { G.trigger("postFixed.ScrollToFixed") } else { G.trigger("postUnfixed.ScrollToFixed") } } } var C = function (I) { if (G.is(":visible")) { c = false; A() } }; var F = function (I) { (!!window.requestAnimationFrame) ? requestAnimationFrame(A) : A() }; var B = function () { var J = document.body; if (document.createElement && J && J.appendChild && J.removeChild) { var L = document.createElement("div"); if (!L.getBoundingClientRect) { return null } L.innerHTML = "x"; L.style.cssText = "position:fixed;top:100px;"; J.appendChild(L); var M = J.style.height, N = J.scrollTop; J.style.height = "3000px"; J.scrollTop = 500; var I = L.getBoundingClientRect().top; J.style.height = M; var K = (I === 100); J.removeChild(L); J.scrollTop = N; return K } return null }; var r = function (I) { I = I || window.event; if (I.preventDefault) { I.preventDefault() } I.returnValue = false }; l.init = function () { l.options = a.extend({}, a.ScrollToFixed.defaultOptions, i); y = G.css("z-index"); l.$el.css("z-index", l.options.zIndex); t = a("<div />"); H = G.css("position"); E = G.css("position"); e = G.css("top"); if (h()) { l.$el.after(t) } a(window).bind("resize.ScrollToFixed", C); a(window).bind("scroll.ScrollToFixed", F); if ("ontouchmove" in window) { a(window).bind("touchmove.ScrollToFixed", A) } if (l.options.preFixed) { G.bind("preFixed.ScrollToFixed", l.options.preFixed) } if (l.options.postFixed) { G.bind("postFixed.ScrollToFixed", l.options.postFixed) } if (l.options.preUnfixed) { G.bind("preUnfixed.ScrollToFixed", l.options.preUnfixed) } if (l.options.postUnfixed) { G.bind("postUnfixed.ScrollToFixed", l.options.postUnfixed) } if (l.options.preAbsolute) { G.bind("preAbsolute.ScrollToFixed", l.options.preAbsolute) } if (l.options.postAbsolute) { G.bind("postAbsolute.ScrollToFixed", l.options.postAbsolute) } if (l.options.fixed) { G.bind("fixed.ScrollToFixed", l.options.fixed) } if (l.options.unfixed) { G.bind("unfixed.ScrollToFixed", l.options.unfixed) } if (l.options.spacerClass) { t.addClass(l.options.spacerClass) } G.bind("resize.ScrollToFixed", function () { t.height(G.height()) }); G.bind("scroll.ScrollToFixed", function () { G.trigger("preUnfixed.ScrollToFixed"); k(); G.trigger("unfixed.ScrollToFixed"); A() }); G.bind("detach.ScrollToFixed", function (I) { r(I); G.trigger("preUnfixed.ScrollToFixed"); k(); G.trigger("unfixed.ScrollToFixed"); a(window).unbind("resize.ScrollToFixed", C); a(window).unbind("scroll.ScrollToFixed", F); G.unbind(".ScrollToFixed"); t.remove(); l.$el.removeData("ScrollToFixed") }); C() }; l.init() }; a.ScrollToFixed.defaultOptions = { marginTop: 0, limit: 0, bottom: -1, zIndex: 1000, baseClassName: "scroll-to-fixed-fixed" }; a.fn.scrollToFixed = function (b) { return this.each(function () { (new a.ScrollToFixed(this, b)) }) } })(jQuery);


/*
 * hystModal
 * https://github.com/AddMoreScripts/hystModal
 *
 */
(function(r,o){typeof exports=="object"&&typeof module<"u"?module.exports=o():typeof define=="function"&&define.amd?define(o):(r=typeof globalThis<"u"?globalThis:r||self,r.HystModal=o())})(this,function(){"use strict";var D=Object.defineProperty;var z=(r,o,d)=>o in r?D(r,o,{enumerable:!0,configurable:!0,writable:!0,value:d}):r[o]=d;var u=(r,o,d)=>(z(r,typeof o!="symbol"?o+"":o,d),d);/**
 * tua-body-scroll-lock v1.2.1
 * (c) 2021 Evinma, BuptStEve
 * @license MIT
 */var r=function(){return typeof window>"u"},o=function(e){e=e||navigator.userAgent;var t=/(iPad).*OS\s([\d_]+)/.test(e),s=!t&&/(iPhone\sOS)\s([\d_]+)/.test(e),n=/(Android);?[\s/]+([\d.]+)?/.test(e),i=s||t;return{ios:i,android:n}};function d(c){if(r())return!1;if(!c)throw new Error("options must be provided");var e=!1,t={get passive(){e=!0}},s=function(){},n="__TUA_BSL_TEST_PASSIVE__";window.addEventListener(n,s,t),window.removeEventListener(n,s,t);var i=c.capture;return e?c:typeof i<"u"?i:!1}var v=0,S=0,O=0,m=null,f=!1,h=[],L=d({passive:!1}),M=!r()&&"scrollBehavior"in document.documentElement.style,T=function(){var e=document.body,t=Object.assign({},e.style),s=window.innerWidth-e.clientWidth;return e.style.overflow="hidden",e.style.boxSizing="border-box",e.style.paddingRight="".concat(s,"px"),function(){["overflow","boxSizing","paddingRight"].forEach(function(n){e.style[n]=t[n]||""})}},E=function(){var e=document.documentElement,t=document.body,s=e.scrollTop||t.scrollTop,n=Object.assign({},e.style),i=Object.assign({},t.style);return e.style.height="100%",e.style.overflow="hidden",t.style.top="-".concat(s,"px"),t.style.width="100%",t.style.height="auto",t.style.position="fixed",t.style.overflow="hidden",function(){e.style.height=n.height||"",e.style.overflow=n.overflow||"",["top","width","height","overflow","position"].forEach(function(l){t.style[l]=i[l]||""}),M?window.scrollTo({top:s,behavior:"instant"}):window.scrollTo(0,s)}},g=function(e){e.cancelable&&e.preventDefault()},A=function(e,t){if(t){var s=t.scrollTop,n=t.scrollLeft,i=t.scrollWidth,l=t.scrollHeight,a=t.clientWidth,p=t.clientHeight,w=e.targetTouches[0].clientX-O,b=e.targetTouches[0].clientY-S,k=Math.abs(b)>Math.abs(w),j=b>0&&s===0,C=w>0&&n===0,P=w<0&&n+a+1>=i,I=b<0&&s+p+1>=l;if(k&&(j||I)||!k&&(C||P))return g(e)}return e.stopPropagation(),!0},B=function(e){e||e!==null&&process.env.NODE_ENV!=="production"&&console.warn("If scrolling is also required in the floating layer, the target element must be provided.")},x=function(e){if(!r()){if(B(e),o().ios){if(e){var t=Array.isArray(e)?e:[e];t.forEach(function(s){s&&h.indexOf(s)===-1&&(s.ontouchstart=function(n){S=n.targetTouches[0].clientY,O=n.targetTouches[0].clientX},s.ontouchmove=function(n){n.targetTouches.length===1&&A(n,s)},h.push(s))})}f||(document.addEventListener("touchmove",g,L),f=!0)}else v<=0&&(m=o().android?E():T());v+=1}},_=function(){if(!r()){if(v=0,!o().ios&&typeof m=="function"){m();return}if(h.length)for(var e=h.pop();e;)e.ontouchmove=null,e.ontouchstart=null,e=h.pop();f&&(document.removeEventListener("touchmove",g,L),f=!1)}};const W="";class y{constructor(e){u(this,"stopTrigger",!1);u(this,"openedModals",[]);u(this,"isBodyLocked",!1);u(this,"isBusy",!1);u(this,"config",{linkAttributeName:"data-hystmodal",closeOnEsc:!0,closeOnOverlay:!0,closeOnButton:!0,catchFocus:!0,isStacked:!1,backscroll:!0,waitTransitions:!1,fixedSelectors:["[data-hystfixed]"]});u(this,"focusElements",["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',"select:not([disabled]):not([aria-hidden])","textarea:not([disabled]):not([aria-hidden])","button:not([disabled]):not([aria-hidden])","iframe","object","embed","[contenteditable]",'[tabindex]:not([tabindex^="-"])']);this.config=Object.assign(this.config,e),this.eventsFeeler()}init(){return this}eventsFeeler(){let e=!1;document.addEventListener("click",t=>{const s=t.target,n=s.closest(`[${this.config.linkAttributeName}]`);if(n&&!this.isBusy){this.isBusy=!0,t.preventDefault();const a=this.config.linkAttributeName,p=a?n.getAttribute(a):null;p&&this.open(p,n.hasAttribute("data-stacked"),n);return}const i=s.closest("[data-hystclose]");if(this.config.closeOnButton&&i&&!this.isBusy){this.isBusy=!0,t.preventDefault();const a=s.closest(".hystmodal");a&&this.close(a);return}if((s.classList.contains("hystmodal")||s.classList.contains("hystmodal__wrap"))&&e&&!this.isBusy){this.isBusy=!0,t.preventDefault();const a=s.closest(".hystmodal");a&&this.close(a)}}),document.addEventListener("mousedown",({target:t})=>{e=!1,!(!this.config.closeOnOverlay||!(t instanceof HTMLElement)||!(t.classList.contains("hystmodal")||t.classList.contains("hystmodal__wrap")))&&(e=!0)}),window.addEventListener("keydown",t=>{var s;if(this.config.closeOnEsc&&t.key==="Escape"&&this.openedModals.length&&!this.isBusy){t.preventDefault(),this.isBusy=!0,this.close((s=this.openedModals[this.openedModals.length-1])==null?void 0:s.element);return}this.config.catchFocus&&t.key==="Tab"&&this.openedModals.length&&this.focusCatcher(t)})}async openObj(e,t=!1){if(this.config.beforeOpen&&this.config.beforeOpen(e,this),this.stopTrigger){this.stopTrigger=!1;return}if(this.config.isStacked||t){const i=this.openedModals.filter(l=>l.element===e.element);await Promise.all(i.map(async l=>{await this.closeObj(l,!1,!0,!1)}))}else await this.closeAll(),this.openedModals=[];if(this.isBodyLocked||this.bodyScrollControl(e,"opening"),!e.element.querySelector(".hystmodal__window")){console.error("Warning: selector .hystmodal__window not found in modal window"),this.isBusy=!1;return}this.openedModals.push(e),e.element.classList.add("hystmodal--animated"),e.element.classList.add("hystmodal--active"),e.element.style.zIndex=e.zIndex.toString(),e.element.setAttribute("aria-hidden","false");const n=getComputedStyle(e.element).getPropertyValue("--hystmodal-speed");this.focusIn(e.element),setTimeout(()=>{e.element.classList.remove("hystmodal--animated"),this.isBusy=!1},y.cssParseSpeed(n))}async open(e,t=this.config.isStacked,s=null){const n=this.getActiveModal(),i=e?document.querySelector(e):null;if(!i){console.error("Warning: selector .hystmodal__window not found in modal window"),this.isBusy=!1;return}const l=getComputedStyle(i).getPropertyValue("--hystmodal-zindex"),a={element:i,openedWindow:i,starter:s,zIndex:n?n.zIndex+this.openedModals.length:parseInt(l,10),config:this.config,isOpened:!1};await this.openObj(a,t),this.isBusy=!1}closeObj(e,t=!1,s=!1,n=!0){return new Promise(i=>{if(!e)return;this.config.waitTransitions&&!s&&(e.element.classList.add("hystmodal--animated"),e.element.classList.add("hystmodal--moved")),e.element.classList.remove("hystmodal--active");const l=getComputedStyle(e.element).getPropertyValue("--hystmodal-speed");e.element.setAttribute("aria-hidden","false"),this.openedModals=this.openedModals.filter(a=>a.element!==e.element),setTimeout(()=>{e.element.classList.remove("hystmodal--animated"),e.element.classList.remove("hystmodal--moved"),e.element.style.zIndex="",this.config.backscroll&&!this.openedModals.length&&t&&(_(),this.bodyScrollControl(e,"closing"),this.isBodyLocked=!1),this.config.catchFocus&&e.starter&&n&&e.starter.focus(),this.config.afterClose&&this.config.afterClose(e,this),i(e)},this.config.waitTransitions&&!s?y.cssParseSpeed(l):0)})}async close(e=null){if(!e){const s=await this.closeAll();return s.length?s[s.length-1]:null}const t=this.openedModals.find(s=>s.element===e);return t?(await this.closeObj(t,!0),this.isBusy=!1,t):null}async closeAll(){const e=[];return await Promise.all(this.openedModals.map(async t=>{await this.closeObj(t,!0),e.push(t)})),this.openedModals=[],this.isBusy=!1,e}focusIn(e){if(!this.openedModals.length)return;const t=Array.from(e.querySelectorAll(this.focusElements.join(", ")));t.length&&t[0].focus()}focusCatcher(e){const t=this.openedModals[this.openedModals.length-1],s=Array.from(t.element.querySelectorAll(this.focusElements.join(", ")));if(!t.element.contains(document.activeElement))s[0].focus(),e.preventDefault();else{if(!document.activeElement)return;const n=s.indexOf(document.activeElement);e.shiftKey&&n===0&&(s[s.length-1].focus(),e.preventDefault()),!e.shiftKey&&n===s.length-1&&(s[0].focus(),e.preventDefault())}}static cssParseSpeed(e){const t=parseFloat(e),s=e.match(/m?s/),n=s?s[0]:null;let i=0;switch(n){case"s":i=t*1e3;break;case"ms":i=t;break}return i}getActiveModal(){return this.openedModals.length?this.openedModals[this.openedModals.length-1]:null}bodyScrollControl(e,t){const s=Array.from(this.config.fixedSelectors?document.querySelectorAll(this.config.fixedSelectors.join(", ")):[]);if(t==="closing"){if(this.openedModals.length)return;s.forEach(i=>{i.style.marginRight=""}),document.documentElement.classList.remove("hystmodal__opened");return}if(this.config.backscroll&&!this.isBodyLocked){const i=Array.from(e.element.querySelectorAll("[data-needscroll], .ss-list"));i.push(e.element),x(i),this.isBodyLocked=!0}const n=parseFloat(document.body.style.paddingRight);n&&s.forEach(i=>{i.style.marginRight=`${parseInt(getComputedStyle(i).marginRight,10)+n}px`}),document.documentElement.classList.add("hystmodal__opened")}}return y});

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.3.15
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */

!function (a) { "use strict"; "function" == typeof define && define.amd ? define(["jquery"], a) : "undefined" != typeof exports ? module.exports = a(require("jquery")) : a(jQuery) }(function (a) { "use strict"; var b = window.Slick || {}; b = function () { function c(c, d) { var f, g, e = this; if (e.defaults = { accessibility: !0, adaptiveHeight: !1, appendArrows: a(c), appendDots: a(c), arrows: !0, asNavFor: null, prevArrow: '<button type="button" data-role="none" class="slick-prev">Previous</button>', nextArrow: '<button type="button" data-role="none" class="slick-next">Next</button>', autoplay: !1, autoplaySpeed: 3e3, centerMode: !1, centerPadding: "50px", cssEase: "ease", customPaging: function (a, b) { return '<button type="button" data-role="none">' + (b + 1) + "</button>" }, dots: !1, dotsClass: "slick-dots", draggable: !0, easing: "linear", fade: !1, focusOnSelect: !1, infinite: !0, initialSlide: 0, lazyLoad: "ondemand", onBeforeChange: null, onAfterChange: null, onInit: null, onReInit: null, onSetPosition: null, pauseOnHover: !0, pauseOnDotsHover: !1, respondTo: "window", responsive: null, rtl: !1, slide: "div", slidesToShow: 1, slidesToScroll: 1, speed: 500, swipe: !0, swipeToSlide: !1, touchMove: !0, touchThreshold: 5, useCSS: !0, variableWidth: !1, vertical: !1, waitForAnimate: !0 }, e.initials = { animating: !1, dragging: !1, autoPlayTimer: null, currentDirection: 0, currentLeft: null, currentSlide: 0, direction: 1, $dots: null, listWidth: null, listHeight: null, loadIndex: 0, $nextArrow: null, $prevArrow: null, slideCount: null, slideWidth: null, $slideTrack: null, $slides: null, sliding: !1, slideOffset: 0, swipeLeft: null, $list: null, touchObject: {}, transformsEnabled: !1 }, a.extend(e, e.initials), e.activeBreakpoint = null, e.animType = null, e.animProp = null, e.breakpoints = [], e.breakpointSettings = [], e.cssTransitions = !1, e.paused = !1, e.positionProp = null, e.respondTo = null, e.shouldClick = !0, e.$slider = a(c), e.$slidesCache = null, e.transformType = null, e.transitionType = null, e.windowWidth = 0, e.windowTimer = null, e.options = a.extend({}, e.defaults, d), e.currentSlide = e.options.initialSlide, e.originalSettings = e.options, f = e.options.responsive || null, f && f.length > -1) { e.respondTo = e.options.respondTo || "window"; for (g in f) f.hasOwnProperty(g) && (e.breakpoints.push(f[g].breakpoint), e.breakpointSettings[f[g].breakpoint] = f[g].settings); e.breakpoints.sort(function (a, b) { return b - a }) } e.autoPlay = a.proxy(e.autoPlay, e), e.autoPlayClear = a.proxy(e.autoPlayClear, e), e.changeSlide = a.proxy(e.changeSlide, e), e.clickHandler = a.proxy(e.clickHandler, e), e.selectHandler = a.proxy(e.selectHandler, e), e.setPosition = a.proxy(e.setPosition, e), e.swipeHandler = a.proxy(e.swipeHandler, e), e.dragHandler = a.proxy(e.dragHandler, e), e.keyHandler = a.proxy(e.keyHandler, e), e.autoPlayIterator = a.proxy(e.autoPlayIterator, e), e.instanceUid = b++, e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, e.init(), e.checkResponsive() } var b = 0; return c }(), b.prototype.addSlide = function (b, c, d) { var e = this; if ("boolean" == typeof c) d = c, c = null; else if (0 > c || c >= e.slideCount) return !1; e.unload(), "number" == typeof c ? 0 === c && 0 === e.$slides.length ? a(b).appendTo(e.$slideTrack) : d ? a(b).insertBefore(e.$slides.eq(c)) : a(b).insertAfter(e.$slides.eq(c)) : d === !0 ? a(b).prependTo(e.$slideTrack) : a(b).appendTo(e.$slideTrack), e.$slides = e.$slideTrack.children(this.options.slide), e.$slideTrack.children(this.options.slide).detach(), e.$slideTrack.append(e.$slides), e.$slides.each(function (b, c) { a(c).attr("index", b) }), e.$slidesCache = e.$slides, e.reinit() }, b.prototype.animateSlide = function (b, c) { var d = {}, e = this; if (1 === e.options.slidesToShow && e.options.adaptiveHeight === !0 && e.options.vertical === !1) { var f = e.$slides.eq(e.currentSlide).outerHeight(!0); e.$list.animate({ height: f }, e.options.speed) } e.options.rtl === !0 && e.options.vertical === !1 && (b = -b), e.transformsEnabled === !1 ? e.options.vertical === !1 ? e.$slideTrack.animate({ left: b }, e.options.speed, e.options.easing, c) : e.$slideTrack.animate({ top: b }, e.options.speed, e.options.easing, c) : e.cssTransitions === !1 ? a({ animStart: e.currentLeft }).animate({ animStart: b }, { duration: e.options.speed, easing: e.options.easing, step: function (a) { e.options.vertical === !1 ? (d[e.animType] = "translate(" + a + "px, 0px)", e.$slideTrack.css(d)) : (d[e.animType] = "translate(0px," + a + "px)", e.$slideTrack.css(d)) }, complete: function () { c && c.call() } }) : (e.applyTransition(), d[e.animType] = e.options.vertical === !1 ? "translate3d(" + b + "px, 0px, 0px)" : "translate3d(0px," + b + "px, 0px)", e.$slideTrack.css(d), c && setTimeout(function () { e.disableTransition(), c.call() }, e.options.speed)) }, b.prototype.asNavFor = function (b) { var c = this, d = null != c.options.asNavFor ? a(c.options.asNavFor).getSlick() : null; null != d && d.slideHandler(b, !0) }, b.prototype.applyTransition = function (a) { var b = this, c = {}; c[b.transitionType] = b.options.fade === !1 ? b.transformType + " " + b.options.speed + "ms " + b.options.cssEase : "opacity " + b.options.speed + "ms " + b.options.cssEase, b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c) }, b.prototype.autoPlay = function () { var a = this; a.autoPlayTimer && clearInterval(a.autoPlayTimer), a.slideCount > a.options.slidesToShow && a.paused !== !0 && (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed)) }, b.prototype.autoPlayClear = function () { var a = this; a.autoPlayTimer && clearInterval(a.autoPlayTimer) }, b.prototype.autoPlayIterator = function () { var a = this; a.options.infinite === !1 ? 1 === a.direction ? (a.currentSlide + 1 === a.slideCount - 1 && (a.direction = 0), a.slideHandler(a.currentSlide + a.options.slidesToScroll)) : (0 === a.currentSlide - 1 && (a.direction = 1), a.slideHandler(a.currentSlide - a.options.slidesToScroll)) : a.slideHandler(a.currentSlide + a.options.slidesToScroll) }, b.prototype.buildArrows = function () { var b = this; b.options.arrows === !0 && b.slideCount > b.options.slidesToShow && (b.$prevArrow = a(b.options.prevArrow), b.$nextArrow = a(b.options.nextArrow), b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.appendTo(b.options.appendArrows), b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows), b.options.infinite !== !0 && b.$prevArrow.addClass("slick-disabled")) }, b.prototype.buildDots = function () { var c, d, b = this; if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) { for (d = '<ul class="' + b.options.dotsClass + '">', c = 0; c <= b.getDotCount(); c += 1)d += "<li>" + b.options.customPaging.call(this, b, c) + "</li>"; d += "</ul>", b.$dots = a(d).appendTo(b.options.appendDots), b.$dots.find("li").first().addClass("slick-active") } }, b.prototype.buildOut = function () { var b = this; b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), b.slideCount = b.$slides.length, b.$slides.each(function (b, c) { a(c).attr("index", b) }), b.$slidesCache = b.$slides, b.$slider.addClass("slick-slider"), b.$slideTrack = 0 === b.slideCount ? a('<div class="slick-track"/>').appendTo(b.$slider) : b.$slides.wrapAll('<div class="slick-track"/>').parent(), b.$list = b.$slideTrack.wrap('<div class="slick-list"/>').parent(), b.$slideTrack.css("opacity", 0), b.options.centerMode === !0 && (b.options.slidesToScroll = 1), a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"), b.setupInfinite(), b.buildArrows(), b.buildDots(), b.updateDots(), b.options.accessibility === !0 && b.$list.prop("tabIndex", 0), b.setSlideClasses("number" == typeof this.currentSlide ? this.currentSlide : 0), b.options.draggable === !0 && b.$list.addClass("draggable") }, b.prototype.checkResponsive = function () { var c, d, e, b = this, f = b.$slider.width(), g = window.innerWidth || a(window).width(); if ("window" === b.respondTo ? e = g : "slider" === b.respondTo ? e = f : "min" === b.respondTo && (e = Math.min(g, f)), b.originalSettings.responsive && b.originalSettings.responsive.length > -1 && null !== b.originalSettings.responsive) { d = null; for (c in b.breakpoints) b.breakpoints.hasOwnProperty(c) && e < b.breakpoints[c] && (d = b.breakpoints[c]); null !== d ? null !== b.activeBreakpoint ? d !== b.activeBreakpoint && (b.activeBreakpoint = d, b.options = a.extend({}, b.originalSettings, b.breakpointSettings[d]), b.refresh()) : (b.activeBreakpoint = d, b.options = a.extend({}, b.originalSettings, b.breakpointSettings[d]), b.refresh()) : null !== b.activeBreakpoint && (b.activeBreakpoint = null, b.options = b.originalSettings, b.refresh()) } }, b.prototype.changeSlide = function (b, c) { var f, g, h, i, j, d = this, e = a(b.target); switch (e.is("a") && b.preventDefault(), h = 0 !== d.slideCount % d.options.slidesToScroll, f = h ? 0 : (d.slideCount - d.currentSlide) % d.options.slidesToScroll, b.data.message) { case "previous": g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f, d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide - g, !1, c); break; case "next": g = 0 === f ? d.options.slidesToScroll : f, d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide + g, !1, c); break; case "index": var k = 0 === b.data.index ? 0 : b.data.index || a(b.target).parent().index() * d.options.slidesToScroll; if (i = d.getNavigableIndexes(), j = 0, i[k] && i[k] === k) if (k > i[i.length - 1]) k = i[i.length - 1]; else for (var l in i) { if (k < i[l]) { k = j; break } j = i[l] } d.slideHandler(k, !1, c); default: return } }, b.prototype.clickHandler = function (a) { var b = this; b.shouldClick === !1 && (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault()) }, b.prototype.destroy = function () { var b = this; b.autoPlayClear(), b.touchObject = {}, a(".slick-cloned", b.$slider).remove(), b.$dots && b.$dots.remove(), b.$prevArrow && "object" != typeof b.options.prevArrow && b.$prevArrow.remove(), b.$nextArrow && "object" != typeof b.options.nextArrow && b.$nextArrow.remove(), b.$slides.parent().hasClass("slick-track") && b.$slides.unwrap().unwrap(), b.$slides.removeClass("slick-slide slick-active slick-center slick-visible").removeAttr("index").css({ position: "", left: "", top: "", zIndex: "", opacity: "", width: "" }), b.$slider.removeClass("slick-slider"), b.$slider.removeClass("slick-initialized"), b.$list.off(".slick"), a(window).off(".slick-" + b.instanceUid), a(document).off(".slick-" + b.instanceUid) }, b.prototype.disableTransition = function (a) { var b = this, c = {}; c[b.transitionType] = "", b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c) }, b.prototype.fadeSlide = function (a, b, c) { var d = this; d.cssTransitions === !1 ? (d.$slides.eq(b).css({ zIndex: 1e3 }), d.$slides.eq(b).animate({ opacity: 1 }, d.options.speed, d.options.easing, c), d.$slides.eq(a).animate({ opacity: 0 }, d.options.speed, d.options.easing)) : (d.applyTransition(b), d.applyTransition(a), d.$slides.eq(b).css({ opacity: 1, zIndex: 1e3 }), d.$slides.eq(a).css({ opacity: 0 }), c && setTimeout(function () { d.disableTransition(b), d.disableTransition(a), c.call() }, d.options.speed)) }, b.prototype.filterSlides = function (a) { var b = this; null !== a && (b.unload(), b.$slideTrack.children(this.options.slide).detach(), b.$slidesCache.filter(a).appendTo(b.$slideTrack), b.reinit()) }, b.prototype.getCurrent = function () { var a = this; return a.currentSlide }, b.prototype.getDotCount = function () { var a = this, b = 0, c = 0, d = 0; if (a.options.infinite === !0) d = Math.ceil(a.slideCount / a.options.slidesToScroll); else for (; b < a.slideCount;)++d, b = c + a.options.slidesToShow, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow; return d - 1 }, b.prototype.getLeft = function (a) { var c, d, g, b = this, e = 0; return b.slideOffset = 0, d = b.$slides.first().outerHeight(), b.options.infinite === !0 ? (b.slideCount > b.options.slidesToShow && (b.slideOffset = -1 * b.slideWidth * b.options.slidesToShow, e = -1 * d * b.options.slidesToShow), 0 !== b.slideCount % b.options.slidesToScroll && a + b.options.slidesToScroll > b.slideCount && b.slideCount > b.options.slidesToShow && (a > b.slideCount ? (b.slideOffset = -1 * (b.options.slidesToShow - (a - b.slideCount)) * b.slideWidth, e = -1 * (b.options.slidesToShow - (a - b.slideCount)) * d) : (b.slideOffset = -1 * b.slideCount % b.options.slidesToScroll * b.slideWidth, e = -1 * b.slideCount % b.options.slidesToScroll * d))) : a + b.options.slidesToShow > b.slideCount && (b.slideOffset = (a + b.options.slidesToShow - b.slideCount) * b.slideWidth, e = (a + b.options.slidesToShow - b.slideCount) * d), b.slideCount <= b.options.slidesToShow && (b.slideOffset = 0, e = 0), b.options.centerMode === !0 && b.options.infinite === !0 ? b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2) - b.slideWidth : b.options.centerMode === !0 && (b.slideOffset = 0, b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2)), c = b.options.vertical === !1 ? -1 * a * b.slideWidth + b.slideOffset : -1 * a * d + e, b.options.variableWidth === !0 && (g = b.slideCount <= b.options.slidesToShow || b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow), c = g[0] ? -1 * g[0].offsetLeft : 0, b.options.centerMode === !0 && (g = b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow + 1), c = g[0] ? -1 * g[0].offsetLeft : 0, c += (b.$list.width() - g.outerWidth()) / 2)), c }, b.prototype.getNavigableIndexes = function () { for (var a = this, b = 0, c = 0, d = []; b < a.slideCount;)d.push(b), b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow; return d }, b.prototype.getSlideCount = function () { var c, b = this; if (b.options.swipeToSlide === !0) { var d = null; return b.$slideTrack.find(".slick-slide").each(function (c, e) { return e.offsetLeft + a(e).outerWidth() / 2 > -1 * b.swipeLeft ? (d = e, !1) : void 0 }), c = Math.abs(a(d).attr("index") - b.currentSlide) } return b.options.slidesToScroll }, b.prototype.init = function () { var b = this; a(b.$slider).hasClass("slick-initialized") || (a(b.$slider).addClass("slick-initialized"), b.buildOut(), b.setProps(), b.startLoad(), b.loadSlider(), b.initializeEvents(), b.updateArrows(), b.updateDots()), null !== b.options.onInit && b.options.onInit.call(this, b) }, b.prototype.initArrowEvents = function () { var a = this; a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.on("click.slick", { message: "previous" }, a.changeSlide), a.$nextArrow.on("click.slick", { message: "next" }, a.changeSlide)) }, b.prototype.initDotEvents = function () { var b = this; b.options.dots === !0 && b.slideCount > b.options.slidesToShow && a("li", b.$dots).on("click.slick", { message: "index" }, b.changeSlide), b.options.dots === !0 && b.options.pauseOnDotsHover === !0 && b.options.autoplay === !0 && a("li", b.$dots).on("mouseenter.slick", function () { b.paused = !0, b.autoPlayClear() }).on("mouseleave.slick", function () { b.paused = !1, b.autoPlay() }) }, b.prototype.initializeEvents = function () { var b = this; b.initArrowEvents(), b.initDotEvents(), b.$list.on("touchstart.slick mousedown.slick", { action: "start" }, b.swipeHandler), b.$list.on("touchmove.slick mousemove.slick", { action: "move" }, b.swipeHandler), b.$list.on("touchend.slick mouseup.slick", { action: "end" }, b.swipeHandler), b.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, b.swipeHandler), b.$list.on("click.slick", b.clickHandler), b.options.pauseOnHover === !0 && b.options.autoplay === !0 && (b.$list.on("mouseenter.slick", function () { b.paused = !0, b.autoPlayClear() }), b.$list.on("mouseleave.slick", function () { b.paused = !1, b.autoPlay() })), b.options.accessibility === !0 && b.$list.on("keydown.slick", b.keyHandler), b.options.focusOnSelect === !0 && a(b.options.slide, b.$slideTrack).on("click.slick", b.selectHandler), a(window).on("orientationchange.slick.slick-" + b.instanceUid, function () { b.checkResponsive(), b.setPosition() }), a(window).on("resize.slick.slick-" + b.instanceUid, function () { a(window).width() !== b.windowWidth && (clearTimeout(b.windowDelay), b.windowDelay = window.setTimeout(function () { b.windowWidth = a(window).width(), b.checkResponsive(), b.setPosition() }, 50)) }), a("*[draggable!=true]", b.$slideTrack).on("dragstart", function (a) { a.preventDefault() }), a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition), a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition) }, b.prototype.initUI = function () { var a = this; a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.show(), a.$nextArrow.show()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.show(), a.options.autoplay === !0 && a.autoPlay() }, b.prototype.keyHandler = function (a) { var b = this; 37 === a.keyCode && b.options.accessibility === !0 ? b.changeSlide({ data: { message: "previous" } }) : 39 === a.keyCode && b.options.accessibility === !0 && b.changeSlide({ data: { message: "next" } }) }, b.prototype.lazyLoad = function () { function g(b) { a("img[data-lazy]", b).each(function () { var b = a(this), c = a(this).attr("data-lazy"); b.load(function () { b.animate({ opacity: 1 }, 200) }).css({ opacity: 0 }).attr("src", c).removeAttr("data-lazy").removeClass("slick-loading") }) } var c, d, e, f, b = this; b.options.centerMode === !0 ? b.options.infinite === !0 ? (e = b.currentSlide + (b.options.slidesToShow / 2 + 1), f = e + b.options.slidesToShow + 2) : (e = Math.max(0, b.currentSlide - (b.options.slidesToShow / 2 + 1)), f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide) : (e = b.options.infinite ? b.options.slidesToShow + b.currentSlide : b.currentSlide, f = e + b.options.slidesToShow, b.options.fade === !0 && (e > 0 && e--, f <= b.slideCount && f++)), c = b.$slider.find(".slick-slide").slice(e, f), g(c), b.slideCount <= b.options.slidesToShow ? (d = b.$slider.find(".slick-slide"), g(d)) : b.currentSlide >= b.slideCount - b.options.slidesToShow ? (d = b.$slider.find(".slick-cloned").slice(0, b.options.slidesToShow), g(d)) : 0 === b.currentSlide && (d = b.$slider.find(".slick-cloned").slice(-1 * b.options.slidesToShow), g(d)) }, b.prototype.loadSlider = function () { var a = this; a.setPosition(), a.$slideTrack.css({ opacity: 1 }), a.$slider.removeClass("slick-loading"), a.initUI(), "progressive" === a.options.lazyLoad && a.progressiveLazyLoad() }, b.prototype.postSlide = function (a) { var b = this; null !== b.options.onAfterChange && b.options.onAfterChange.call(this, b, a), b.animating = !1, b.setPosition(), b.swipeLeft = null, b.options.autoplay === !0 && b.paused === !1 && b.autoPlay() }, b.prototype.progressiveLazyLoad = function () { var c, d, b = this; c = a("img[data-lazy]", b.$slider).length, c > 0 && (d = a("img[data-lazy]", b.$slider).first(), d.attr("src", d.attr("data-lazy")).removeClass("slick-loading").load(function () { d.removeAttr("data-lazy"), b.progressiveLazyLoad() }).error(function () { d.removeAttr("data-lazy"), b.progressiveLazyLoad() })) }, b.prototype.refresh = function () { var b = this, c = b.currentSlide; b.destroy(), a.extend(b, b.initials), b.init(), b.changeSlide({ data: { message: "index", index: c } }, !0) }, b.prototype.reinit = function () { var b = this; b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide"), b.slideCount = b.$slides.length, b.currentSlide >= b.slideCount && 0 !== b.currentSlide && (b.currentSlide = b.currentSlide - b.options.slidesToScroll), b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0), b.setProps(), b.setupInfinite(), b.buildArrows(), b.updateArrows(), b.initArrowEvents(), b.buildDots(), b.updateDots(), b.initDotEvents(), b.options.focusOnSelect === !0 && a(b.options.slide, b.$slideTrack).on("click.slick", b.selectHandler), b.setSlideClasses(0), b.setPosition(), null !== b.options.onReInit && b.options.onReInit.call(this, b) }, b.prototype.removeSlide = function (a, b, c) { var d = this; return "boolean" == typeof a ? (b = a, a = b === !0 ? 0 : d.slideCount - 1) : a = b === !0 ? --a : a, d.slideCount < 1 || 0 > a || a > d.slideCount - 1 ? !1 : (d.unload(), c === !0 ? d.$slideTrack.children().remove() : d.$slideTrack.children(this.options.slide).eq(a).remove(), d.$slides = d.$slideTrack.children(this.options.slide), d.$slideTrack.children(this.options.slide).detach(), d.$slideTrack.append(d.$slides), d.$slidesCache = d.$slides, d.reinit(), void 0) }, b.prototype.setCSS = function (a) { var d, e, b = this, c = {}; b.options.rtl === !0 && (a = -a), d = "left" == b.positionProp ? a + "px" : "0px", e = "top" == b.positionProp ? a + "px" : "0px", c[b.positionProp] = a, b.transformsEnabled === !1 ? b.$slideTrack.css(c) : (c = {}, b.cssTransitions === !1 ? (c[b.animType] = "translate(" + d + ", " + e + ")", b.$slideTrack.css(c)) : (c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)", b.$slideTrack.css(c))) }, b.prototype.setDimensions = function () { var b = this; if (b.options.vertical === !1 ? b.options.centerMode === !0 && b.$list.css({ padding: "0px " + b.options.centerPadding }) : (b.$list.height(b.$slides.first().outerHeight(!0) * b.options.slidesToShow), b.options.centerMode === !0 && b.$list.css({ padding: b.options.centerPadding + " 0px" })), b.listWidth = b.$list.width(), b.listHeight = b.$list.height(), b.options.vertical === !1 && b.options.variableWidth === !1) b.slideWidth = Math.ceil(b.listWidth / b.options.slidesToShow), b.$slideTrack.width(Math.ceil(b.slideWidth * b.$slideTrack.children(".slick-slide").length)); else if (b.options.variableWidth === !0) { var c = 0; b.slideWidth = Math.ceil(b.listWidth / b.options.slidesToShow), b.$slideTrack.children(".slick-slide").each(function () { c += Math.ceil(a(this).outerWidth(!0)) }), b.$slideTrack.width(Math.ceil(c) + 1) } else b.slideWidth = Math.ceil(b.listWidth), b.$slideTrack.height(Math.ceil(b.$slides.first().outerHeight(!0) * b.$slideTrack.children(".slick-slide").length)); var d = b.$slides.first().outerWidth(!0) - b.$slides.first().width(); b.options.variableWidth === !1 && b.$slideTrack.children(".slick-slide").width(b.slideWidth - d) }, b.prototype.setFade = function () { var c, b = this; b.$slides.each(function (d, e) { c = -1 * b.slideWidth * d, b.options.rtl === !0 ? a(e).css({ position: "relative", right: c, top: 0, zIndex: 800, opacity: 0 }) : a(e).css({ position: "relative", left: c, top: 0, zIndex: 800, opacity: 0 }) }), b.$slides.eq(b.currentSlide).css({ zIndex: 900, opacity: 1 }) }, b.prototype.setHeight = function () { var a = this; if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) { var b = a.$slides.eq(a.currentSlide).outerHeight(!0); a.$list.css("height", b) } }, b.prototype.setPosition = function () { var a = this; a.setDimensions(), a.setHeight(), a.options.fade === !1 ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(), null !== a.options.onSetPosition && a.options.onSetPosition.call(this, a) }, b.prototype.setProps = function () { var a = this, b = document.body.style; a.positionProp = a.options.vertical === !0 ? "top" : "left", "top" === a.positionProp ? a.$slider.addClass("slick-vertical") : a.$slider.removeClass("slick-vertical"), (void 0 !== b.WebkitTransition || void 0 !== b.MozTransition || void 0 !== b.msTransition) && a.options.useCSS === !0 && (a.cssTransitions = !0), void 0 !== b.OTransform && (a.animType = "OTransform", a.transformType = "-o-transform", a.transitionType = "OTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.MozTransform && (a.animType = "MozTransform", a.transformType = "-moz-transform", a.transitionType = "MozTransition", void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)), void 0 !== b.webkitTransform && (a.animType = "webkitTransform", a.transformType = "-webkit-transform", a.transitionType = "webkitTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.msTransform && (a.animType = "msTransform", a.transformType = "-ms-transform", a.transitionType = "msTransition", void 0 === b.msTransform && (a.animType = !1)), void 0 !== b.transform && a.animType !== !1 && (a.animType = "transform", a.transformType = "transform", a.transitionType = "transition"), a.transformsEnabled = null !== a.animType && a.animType !== !1 }, b.prototype.setSlideClasses = function (a) { var c, d, e, f, b = this; b.$slider.find(".slick-slide").removeClass("slick-active").removeClass("slick-center"), d = b.$slider.find(".slick-slide"), b.options.centerMode === !0 ? (c = Math.floor(b.options.slidesToShow / 2), b.options.infinite === !0 && (a >= c && a <= b.slideCount - 1 - c ? b.$slides.slice(a - c, a + c + 1).addClass("slick-active") : (e = b.options.slidesToShow + a, d.slice(e - c + 1, e + c + 2).addClass("slick-active")), 0 === a ? d.eq(d.length - 1 - b.options.slidesToShow).addClass("slick-center") : a === b.slideCount - 1 && d.eq(b.options.slidesToShow).addClass("slick-center")), b.$slides.eq(a).addClass("slick-center")) : a >= 0 && a <= b.slideCount - b.options.slidesToShow ? b.$slides.slice(a, a + b.options.slidesToShow).addClass("slick-active") : d.length <= b.options.slidesToShow ? d.addClass("slick-active") : (f = b.slideCount % b.options.slidesToShow, e = b.options.infinite === !0 ? b.options.slidesToShow + a : a, b.options.slidesToShow == b.options.slidesToScroll && b.slideCount - a < b.options.slidesToShow ? d.slice(e - (b.options.slidesToShow - f), e + f).addClass("slick-active") : d.slice(e, e + b.options.slidesToShow).addClass("slick-active")), "ondemand" === b.options.lazyLoad && b.lazyLoad() }, b.prototype.setupInfinite = function () { var c, d, e, b = this; if (b.options.fade === !0 && (b.options.centerMode = !1), b.options.infinite === !0 && b.options.fade === !1 && (d = null, b.slideCount > b.options.slidesToShow)) { for (e = b.options.centerMode === !0 ? b.options.slidesToShow + 1 : b.options.slidesToShow, c = b.slideCount; c > b.slideCount - e; c -= 1)d = c - 1, a(b.$slides[d]).clone(!0).attr("id", "").attr("index", d - b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned"); for (c = 0; e > c; c += 1)d = c, a(b.$slides[d]).clone(!0).attr("id", "").attr("index", d + b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned"); b.$slideTrack.find(".slick-cloned").find("[id]").each(function () { a(this).attr("id", "") }) } }, b.prototype.selectHandler = function (b) { var c = this, d = parseInt(a(b.target).parents(".slick-slide").attr("index")); return d || (d = 0), c.slideCount <= c.options.slidesToShow ? (c.$slider.find(".slick-slide").removeClass("slick-active"), c.$slides.eq(d).addClass("slick-active"), c.options.centerMode === !0 && (c.$slider.find(".slick-slide").removeClass("slick-center"), c.$slides.eq(d).addClass("slick-center")), c.asNavFor(d), void 0) : (c.slideHandler(d), void 0) }, b.prototype.slideHandler = function (a, b, c) { var d, e, f, g, i = null, j = this; return b = b || !1, j.animating === !0 && j.options.waitForAnimate === !0 || j.options.fade === !0 && j.currentSlide === a || j.slideCount <= j.options.slidesToShow ? void 0 : (b === !1 && j.asNavFor(a), d = a, i = j.getLeft(d), g = j.getLeft(j.currentSlide), j.currentLeft = null === j.swipeLeft ? g : j.swipeLeft, j.options.infinite === !1 && j.options.centerMode === !1 && (0 > a || a > j.getDotCount() * j.options.slidesToScroll) ? (j.options.fade === !1 && (d = j.currentSlide, c !== !0 ? j.animateSlide(g, function () { j.postSlide(d) }) : j.postSlide(d)), void 0) : j.options.infinite === !1 && j.options.centerMode === !0 && (0 > a || a > j.slideCount - j.options.slidesToScroll) ? (j.options.fade === !1 && (d = j.currentSlide, c !== !0 ? j.animateSlide(g, function () { j.postSlide(d) }) : j.postSlide(d)), void 0) : (j.options.autoplay === !0 && clearInterval(j.autoPlayTimer), e = 0 > d ? 0 !== j.slideCount % j.options.slidesToScroll ? j.slideCount - j.slideCount % j.options.slidesToScroll : j.slideCount + d : d >= j.slideCount ? 0 !== j.slideCount % j.options.slidesToScroll ? 0 : d - j.slideCount : d, j.animating = !0, null !== j.options.onBeforeChange && a !== j.currentSlide && j.options.onBeforeChange.call(this, j, j.currentSlide, e), f = j.currentSlide, j.currentSlide = e, j.setSlideClasses(j.currentSlide), j.updateDots(), j.updateArrows(), j.options.fade === !0 ? (c !== !0 ? j.fadeSlide(f, e, function () { j.postSlide(e) }) : j.postSlide(e), void 0) : (c !== !0 ? j.animateSlide(i, function () { j.postSlide(e) }) : j.postSlide(e), void 0))) }, b.prototype.startLoad = function () { var a = this; a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.hide(), a.$nextArrow.hide()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.hide(), a.$slider.addClass("slick-loading") }, b.prototype.swipeDirection = function () { var a, b, c, d, e = this; return a = e.touchObject.startX - e.touchObject.curX, b = e.touchObject.startY - e.touchObject.curY, c = Math.atan2(b, a), d = Math.round(180 * c / Math.PI), 0 > d && (d = 360 - Math.abs(d)), 45 >= d && d >= 0 ? e.options.rtl === !1 ? "left" : "right" : 360 >= d && d >= 315 ? e.options.rtl === !1 ? "left" : "right" : d >= 135 && 225 >= d ? e.options.rtl === !1 ? "right" : "left" : "vertical" }, b.prototype.swipeEnd = function () { var b = this; if (b.dragging = !1, b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0, void 0 === b.touchObject.curX) return !1; if (b.touchObject.swipeLength >= b.touchObject.minSwipe) switch (b.swipeDirection()) { case "left": b.slideHandler(b.currentSlide + b.getSlideCount()), b.currentDirection = 0, b.touchObject = {}; break; case "right": b.slideHandler(b.currentSlide - b.getSlideCount()), b.currentDirection = 1, b.touchObject = {} } else b.touchObject.startX !== b.touchObject.curX && (b.slideHandler(b.currentSlide), b.touchObject = {}) }, b.prototype.swipeHandler = function (a) { var b = this; if (!(b.options.swipe === !1 || "ontouchend" in document && b.options.swipe === !1 || b.options.draggable === !1 && -1 !== a.type.indexOf("mouse"))) switch (b.touchObject.fingerCount = a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1, b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold, a.data.action) { case "start": b.swipeStart(a); break; case "move": b.swipeMove(a); break; case "end": b.swipeEnd(a) } }, b.prototype.swipeMove = function (a) { var c, d, e, f, b = this; return f = void 0 !== a.originalEvent ? a.originalEvent.touches : null, !b.dragging || f && 1 !== f.length ? !1 : (c = b.getLeft(b.currentSlide), b.touchObject.curX = void 0 !== f ? f[0].pageX : a.clientX, b.touchObject.curY = void 0 !== f ? f[0].pageY : a.clientY, b.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))), d = b.swipeDirection(), "vertical" !== d ? (void 0 !== a.originalEvent && b.touchObject.swipeLength > 4 && a.preventDefault(), e = (b.options.rtl === !1 ? 1 : -1) * (b.touchObject.curX > b.touchObject.startX ? 1 : -1), b.swipeLeft = b.options.vertical === !1 ? c + b.touchObject.swipeLength * e : c + b.touchObject.swipeLength * (b.$list.height() / b.listWidth) * e, b.options.fade === !0 || b.options.touchMove === !1 ? !1 : b.animating === !0 ? (b.swipeLeft = null, !1) : (b.setCSS(b.swipeLeft), void 0)) : void 0) }, b.prototype.swipeStart = function (a) { var c, b = this; return 1 !== b.touchObject.fingerCount || b.slideCount <= b.options.slidesToShow ? (b.touchObject = {}, !1) : (void 0 !== a.originalEvent && void 0 !== a.originalEvent.touches && (c = a.originalEvent.touches[0]), b.touchObject.startX = b.touchObject.curX = void 0 !== c ? c.pageX : a.clientX, b.touchObject.startY = b.touchObject.curY = void 0 !== c ? c.pageY : a.clientY, b.dragging = !0, void 0) }, b.prototype.unfilterSlides = function () { var a = this; null !== a.$slidesCache && (a.unload(), a.$slideTrack.children(this.options.slide).detach(), a.$slidesCache.appendTo(a.$slideTrack), a.reinit()) }, b.prototype.unload = function () { var b = this; a(".slick-cloned", b.$slider).remove(), b.$dots && b.$dots.remove(), b.$prevArrow && "object" != typeof b.options.prevArrow && b.$prevArrow.remove(), b.$nextArrow && "object" != typeof b.options.nextArrow && b.$nextArrow.remove(), b.$slides.removeClass("slick-slide slick-active slick-visible").css("width", "") }, b.prototype.updateArrows = function () { var b, a = this; b = Math.floor(a.options.slidesToShow / 2), a.options.arrows === !0 && a.options.infinite !== !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.removeClass("slick-disabled"), a.$nextArrow.removeClass("slick-disabled"), 0 === a.currentSlide ? (a.$prevArrow.addClass("slick-disabled"), a.$nextArrow.removeClass("slick-disabled")) : a.currentSlide >= a.slideCount - a.options.slidesToShow && a.options.centerMode === !1 ? (a.$nextArrow.addClass("slick-disabled"), a.$prevArrow.removeClass("slick-disabled")) : a.currentSlide > a.slideCount - a.options.slidesToShow + b && a.options.centerMode === !0 && (a.$nextArrow.addClass("slick-disabled"), a.$prevArrow.removeClass("slick-disabled"))) }, b.prototype.updateDots = function () { var a = this; null !== a.$dots && (a.$dots.find("li").removeClass("slick-active"), a.$dots.find("li").eq(Math.floor(a.currentSlide / a.options.slidesToScroll)).addClass("slick-active")) }, a.fn.slick = function (a) { var c = this; return c.each(function (c, d) { d.slick = new b(d, a) }) }, a.fn.slickAdd = function (a, b, c) { var d = this; return d.each(function (d, e) { e.slick.addSlide(a, b, c) }) }, a.fn.slickCurrentSlide = function () { var a = this; return a.get(0).slick.getCurrent() }, a.fn.slickFilter = function (a) { var b = this; return b.each(function (b, c) { c.slick.filterSlides(a) }) }, a.fn.slickGoTo = function (a, b) { var c = this; return c.each(function (c, d) { d.slick.changeSlide({ data: { message: "index", index: parseInt(a) } }, b) }) }, a.fn.slickNext = function () { var a = this; return a.each(function (a, b) { b.slick.changeSlide({ data: { message: "next" } }) }) }, a.fn.slickPause = function () { var a = this; return a.each(function (a, b) { b.slick.autoPlayClear(), b.slick.paused = !0 }) }, a.fn.slickPlay = function () { var a = this; return a.each(function (a, b) { b.slick.paused = !1, b.slick.autoPlay() }) }, a.fn.slickPrev = function () { var a = this; return a.each(function (a, b) { b.slick.changeSlide({ data: { message: "previous" } }) }) }, a.fn.slickRemove = function (a, b) { var c = this; return c.each(function (c, d) { d.slick.removeSlide(a, b) }) }, a.fn.slickRemoveAll = function () { var a = this; return a.each(function (a, b) { b.slick.removeSlide(null, null, !0) }) }, a.fn.slickGetOption = function (a) { var b = this; return b.get(0).slick.options[a] }, a.fn.slickSetOption = function (a, b, c) { var d = this; return d.each(function (d, e) { e.slick.options[a] = b, c === !0 && (e.slick.unload(), e.slick.reinit()) }) }, a.fn.slickUnfilter = function () { var a = this; return a.each(function (a, b) { b.slick.unfilterSlides() }) }, a.fn.unslick = function () { var a = this; return a.each(function (a, b) { b.slick && b.slick.destroy() }) }, a.fn.getSlick = function () { var a = null, b = this; return b.each(function (b, c) { a = c.slick }), a } });
/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!(function (a) { a.fn.prepareTransition = function () { return this.each(function () { var b = a(this); b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () { b.removeClass("is-transitioning") }); var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"]; var d = 0; a.each(c, function (a, c) { d = parseFloat(b.css(c)) || d }); if (d != 0) { b.addClass("is-transitioning"); b[0].offsetWidth } }) } })(jQuery);

/* https://github.com/Stanko/animated-scroll-to/blob/master/lib/animated-scroll-to.js */
var animateScrollTo=function(){"use strict";var e=this&&this.__assign||function(){return(e=Object.assign||function(e){for(var t,n=1,o=arguments.length;n<o;n++)for(var l in t=arguments[n])Object.prototype.hasOwnProperty.call(t,l)&&(e[l]=t[l]);return e}).apply(this,arguments)},t=this&&this.__awaiter||function(e,t,n,o){return new(n||(n=Promise))(function(l,r){function i(e){try{a(o.next(e))}catch(e){r(e)}}function c(e){try{a(o.throw(e))}catch(e){r(e)}}function a(e){var t;e.done?l(e.value):(t=e.value,t instanceof n?t:new n(function(e){e(t)})).then(i,c)}a((o=o.apply(e,t||[])).next())})},n=this&&this.__generator||function(e,t){var n,o,l,r,i={label:0,sent:function(){if(1&l[0])throw l[1];return l[1]},trys:[],ops:[]};return r={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(r[Symbol.iterator]=function(){return this}),r;function c(r){return function(c){return function(r){if(n)throw new TypeError("Generator is already executing.");for(;i;)try{if(n=1,o&&(l=2&r[0]?o.return:r[0]?o.throw||((l=o.return)&&l.call(o),0):o.next)&&!(l=l.call(o,r[1])).done)return l;switch(o=0,l&&(r=[2&r[0],l.value]),r[0]){case 0:case 1:l=r;break;case 4:return i.label++,{value:r[1],done:!1};case 5:i.label++,o=r[1],r=[0];continue;case 7:r=i.ops.pop(),i.trys.pop();continue;default:if(!(l=(l=i.trys).length>0&&l[l.length-1])&&(6===r[0]||2===r[0])){i=0;continue}if(3===r[0]&&(!l||r[1]>l[0]&&r[1]<l[3])){i.label=r[1];break}if(6===r[0]&&i.label<l[1]){i.label=l[1],l=r;break}if(l&&i.label<l[2]){i.label=l[2],i.ops.push(r);break}l[2]&&i.ops.pop(),i.trys.pop();continue}r=t.call(e,i)}catch(e){r=[6,e],o=0}finally{n=l=0}if(5&r[0])throw r[1];return{value:r[0]?r[1]:void 0,done:!0}}([r,c])}}};function o(e){var t=0,n=0,o=e;do{t+=o.offsetTop||0,n+=o.offsetLeft||0,o=o.offsetParent}while(o);return{top:t,left:n}}var l=function(){function e(e){this.element=e}return e.prototype.getHorizontalScroll=function(){return this.element.scrollLeft},e.prototype.getVerticalScroll=function(){return this.element.scrollTop},e.prototype.getMaxHorizontalScroll=function(){return this.element.scrollWidth-this.element.clientWidth},e.prototype.getMaxVerticalScroll=function(){return this.element.scrollHeight-this.element.clientHeight},e.prototype.getHorizontalElementScrollOffset=function(e,t){return o(e).left-o(t).left},e.prototype.getVerticalElementScrollOffset=function(e,t){return o(e).top-o(t).top},e.prototype.scrollTo=function(e,t){this.element.scrollLeft=e,this.element.scrollTop=t},e}(),r=function(){function e(){}return e.prototype.getHorizontalScroll=function(){return window.scrollX||document.documentElement.scrollLeft},e.prototype.getVerticalScroll=function(){return window.scrollY||document.documentElement.scrollTop},e.prototype.getMaxHorizontalScroll=function(){return Math.max(document.body.scrollWidth,document.documentElement.scrollWidth,document.body.offsetWidth,document.documentElement.offsetWidth,document.body.clientWidth,document.documentElement.clientWidth)-window.innerWidth},e.prototype.getMaxVerticalScroll=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.body.clientHeight,document.documentElement.clientHeight)-window.innerHeight},e.prototype.getHorizontalElementScrollOffset=function(e){return(window.scrollX||document.documentElement.scrollLeft)+e.getBoundingClientRect().left},e.prototype.getVerticalElementScrollOffset=function(e){return(window.scrollY||document.documentElement.scrollTop)+e.getBoundingClientRect().top},e.prototype.scrollTo=function(e,t){window.scrollTo(e,t)},e}(),i={elements:[],cancelMethods:[],add:function(e,t){i.elements.push(e),i.cancelMethods.push(t)},remove:function(e,t){void 0===t&&(t=!0);var n=i.elements.indexOf(e);n>-1&&(t&&i.cancelMethods[n](),i.elements.splice(n,1),i.cancelMethods.splice(n,1))}},c="undefined"!=typeof window,a={cancelOnUserAction:!0,easing:function(e){return--e*e*e+1},elementToScroll:c?window:null,horizontalOffset:0,maxDuration:3e3,minDuration:250,speed:500,verticalOffset:0};return function(o,u){return void 0===u&&(u={}),t(this,void 0,void 0,function(){var t,s,m,f,d,h,p,w,g,y,S,v,b,T,E,H,M;return n(this,function(n){if(!c)return[2,new Promise(function(e){e(!1)})];if(!window.Promise)throw"Browser doesn't support Promises, and animated-scroll-to depends on it, please provide a polyfill.";if(f=e(e({},a),u),d=f.elementToScroll===window,h=!!f.elementToScroll.nodeName,!d&&!h)throw"Element to scroll needs to be either window or DOM element.";if(p=d?document.documentElement:f.elementToScroll,"smooth"===getComputedStyle(p).getPropertyValue("scroll-behavior")&&console.warn(p.tagName+' has "scroll-behavior: smooth" which can mess up with animated-scroll-to\'s animations'),w=d?new r:new l(f.elementToScroll),o instanceof Element){if(m=o,h&&(!f.elementToScroll.contains(m)||f.elementToScroll.isSameNode(m)))throw"options.elementToScroll has to be a parent of scrollToElement";t=w.getHorizontalElementScrollOffset(m,f.elementToScroll),s=w.getVerticalElementScrollOffset(m,f.elementToScroll)}else if("number"==typeof o)t=w.getHorizontalScroll(),s=o;else{if(!Array.isArray(o)||2!==o.length)throw"Wrong function signature. Check documentation.\nAvailable method signatures are:\n  animateScrollTo(y:number, options)\n  animateScrollTo([x:number | null, y:number | null], options)\n  animateScrollTo(scrollToElement:Element, options)";t=null===o[0]?w.getHorizontalScroll():o[0],s=null===o[1]?w.getVerticalScroll():o[1]}return t+=f.horizontalOffset,s+=f.verticalOffset,g=w.getMaxHorizontalScroll(),y=w.getHorizontalScroll(),t>g&&(t=g),S=t-y,v=w.getMaxVerticalScroll(),b=w.getVerticalScroll(),s>v&&(s=v),T=s-b,E=Math.abs(Math.round(S/1e3*f.speed)),H=Math.abs(Math.round(T/1e3*f.speed)),(M=E>H?E:H)<f.minDuration?M=f.minDuration:M>f.maxDuration&&(M=f.maxDuration),[2,new Promise(function(e,n){var o;0===S&&0===T&&e(!0),i.remove(f.elementToScroll,!0);var l=function(){u(),cancelAnimationFrame(o),e(!1)};i.add(f.elementToScroll,l);var r=f.cancelOnUserAction?l:function(e){return e.preventDefault()},c=f.cancelOnUserAction?{passive:!0}:{passive:!1},a=["wheel","touchstart","keydown","mousedown"],u=function(){a.forEach(function(e){f.elementToScroll.removeEventListener(e,r,c)})};a.forEach(function(e){f.elementToScroll.addEventListener(e,r,c)});var m=Date.now(),d=function(){var n=Date.now()-m,l=n/M,r=Math.round(y+S*f.easing(l)),c=Math.round(b+T*f.easing(l));n<M&&(r!==t||c!==s)?(w.scrollTo(r,c),o=requestAnimationFrame(d)):(w.scrollTo(t,s),cancelAnimationFrame(o),u(),i.remove(f.elementToScroll,!1),e(!0))};o=requestAnimationFrame(d)})]})})}}();

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
; (function () {
  function n(n, t) { for (var r = -1, e = t.length, u = n.length; ++r < e;)n[u + r] = t[r]; return n } function t(n, t, r) { for (var e = -1, u = n.length; ++e < u;) { var o = n[e], i = t(o); if (null != i && (c === an ? i === i : r(i, c))) var c = i, f = o } return f } function r(n, t, r) { var e; return r(n, function (n, r, u) { return t(n, r, u) ? (e = n, false) : void 0 }), e } function e(n, t, r, e, u) { return u(n, function (n, u, o) { r = e ? (e = false, n) : t(r, n, u, o) }), r } function u(n, t) { return O(t, function (t) { return n[t] }) } function o(n) { return n && n.Object === Object ? n : null } function i(n) {
    return vn[n];
  } function c(n) { var t = false; if (null != n && typeof n.toString != "function") try { t = !!(n + "") } catch (r) { } return t } function f(n, t) { return n = typeof n == "number" || hn.test(n) ? +n : -1, n > -1 && 0 == n % 1 && (null == t ? 9007199254740991 : t) > n } function a(n) { if (Y(n) && !Pn(n)) { if (n instanceof l) return n; if (En.call(n, "__wrapped__")) { var t = new l(n.__wrapped__, n.__chain__); return t.__actions__ = N(n.__actions__), t } } return new l(n) } function l(n, t) { this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t } function p(n, t, r, e) {
    var u; return (u = n === an) || (u = xn[r],
      u = (n === u || n !== n && u !== u) && !En.call(e, r)), u ? t : n
  } function s(n) { return X(n) ? Fn(n) : {} } function h(n, t, r) { if (typeof n != "function") throw new TypeError("Expected a function"); return setTimeout(function () { n.apply(an, r) }, t) } function v(n, t) { var r = true; return $n(n, function (n, e, u) { return r = !!t(n, e, u) }), r } function y(n, t) { var r = []; return $n(n, function (n, e, u) { t(n, e, u) && r.push(n) }), r } function _(t, r, e, u) {
    u || (u = []); for (var o = -1, i = t.length; ++o < i;) {
      var c = t[o]; r > 0 && Y(c) && L(c) && (e || Pn(c) || K(c)) ? r > 1 ? _(c, r - 1, e, u) : n(u, c) : e || (u[u.length] = c);
    } return u
  } function g(n, t) { return n && qn(n, t, en) } function b(n, t) { return y(t, function (t) { return Q(n[t]) }) } function j(n, t, r, e, u) { return n === t ? true : null == n || null == t || !X(n) && !Y(t) ? n !== n && t !== t : m(n, t, j, r, e, u) } function m(n, t, r, e, u, o) {
    var i = Pn(n), f = Pn(t), a = "[object Array]", l = "[object Array]"; i || (a = kn.call(n), "[object Arguments]" == a && (a = "[object Object]")), f || (l = kn.call(t), "[object Arguments]" == l && (l = "[object Object]")); var p = "[object Object]" == a && !c(n), f = "[object Object]" == l && !c(t); return !(l = a == l) || i || p ? 2 & u || (a = p && En.call(n, "__wrapped__"),
      f = f && En.call(t, "__wrapped__"), !a && !f) ? l ? (o || (o = []), (a = J(o, function (t) { return t[0] === n })) && a[1] ? a[1] == t : (o.push([n, t]), t = (i ? I : q)(n, t, r, e, u, o), o.pop(), t)) : false : r(a ? n.value() : n, f ? t.value() : t, e, u, o) : $(n, t, a)
  } function d(n) { var t = typeof n; return "function" == t ? n : null == n ? cn : ("object" == t ? x : A)(n) } function w(n) { n = null == n ? n : Object(n); var t, r = []; for (t in n) r.push(t); return r } function O(n, t) { var r = -1, e = L(n) ? Array(n.length) : []; return $n(n, function (n, u, o) { e[++r] = t(n, u, o) }), e } function x(n) {
    var t = en(n); return function (r) {
      var e = t.length; if (null == r) return !e; for (r = Object(r); e--;) { var u = t[e]; if (!(u in r && j(n[u], r[u], an, 3))) return false } return true
    }
  } function E(n, t) { return n = Object(n), P(t, function (t, r) { return r in n && (t[r] = n[r]), t }, {}) } function A(n) { return function (t) { return null == t ? an : t[n] } } function k(n, t, r) { var e = -1, u = n.length; for (0 > t && (t = -t > u ? 0 : u + t), r = r > u ? u : r, 0 > r && (r += u), u = t > r ? 0 : r - t >>> 0, t >>>= 0, r = Array(u); ++e < u;)r[e] = n[e + t]; return r } function N(n) { return k(n, 0, n.length) } function S(n, t) {
    var r; return $n(n, function (n, e, u) {
      return r = t(n, e, u),
        !r
    }), !!r
  } function T(t, r) { return P(r, function (t, r) { return r.func.apply(r.thisArg, n([t], r.args)) }, t) } function F(n, t, r, e) { r || (r = {}); for (var u = -1, o = t.length; ++u < o;) { var i = t[u], c = e ? e(r[i], n[i], i, r, n) : n[i], f = r, a = f[i]; En.call(f, i) && (a === c || a !== a && c !== c) && (c !== an || i in f) || (f[i] = c) } return r } function R(n) { return V(function (t, r) { var e = -1, u = r.length, o = u > 1 ? r[u - 1] : an, o = typeof o == "function" ? (u--, o) : an; for (t = Object(t); ++e < u;) { var i = r[e]; i && n(t, i, e, o) } return t }) } function B(n) {
    return function () {
      var t = arguments, r = s(n.prototype), t = n.apply(r, t);
      return X(t) ? t : r
    }
  } function D(n, t, r) { function e() { for (var o = -1, i = arguments.length, c = -1, f = r.length, a = Array(f + i), l = this && this !== wn && this instanceof e ? u : n; ++c < f;)a[c] = r[c]; for (; i--;)a[c++] = arguments[++o]; return l.apply(t, a) } if (typeof n != "function") throw new TypeError("Expected a function"); var u = B(n); return e } function I(n, t, r, e, u, o) {
    var i = -1, c = 1 & u, f = n.length, a = t.length; if (f != a && !(2 & u && a > f)) return false; for (a = true; ++i < f;) {
      var l = n[i], p = t[i]; if (void 0 !== an) { a = false; break } if (c) {
        if (!S(t, function (n) {
          return l === n || r(l, n, e, u, o);
        })) { a = false; break }
      } else if (l !== p && !r(l, p, e, u, o)) { a = false; break }
    } return a
  } function $(n, t, r) { switch (r) { case "[object Boolean]": case "[object Date]": return +n == +t; case "[object Error]": return n.name == t.name && n.message == t.message; case "[object Number]": return n != +n ? t != +t : n == +t; case "[object RegExp]": case "[object String]": return n == t + "" }return false } function q(n, t, r, e, u, o) {
    var i = 2 & u, c = en(n), f = c.length, a = en(t).length; if (f != a && !i) return false; for (var l = f; l--;) { var p = c[l]; if (!(i ? p in t : En.call(t, p))) return false } for (a = true; ++l < f;) {
      var p = c[l], s = n[p], h = t[p]; if (void 0 !== an || s !== h && !r(s, h, e, u, o)) { a = false; break } i || (i = "constructor" == p)
    } return a && !i && (r = n.constructor, e = t.constructor, r != e && "constructor" in n && "constructor" in t && !(typeof r == "function" && r instanceof r && typeof e == "function" && e instanceof e) && (a = false)), a
  } function z(n) { var t = n ? n.length : an; if (W(t) && (Pn(n) || nn(n) || K(n))) { n = String; for (var r = -1, e = Array(t); ++r < t;)e[r] = n(r); t = e } else t = null; return t } function C(n) { var t = n && n.constructor, t = Q(t) && t.prototype || xn; return n === t } function G(n) {
    return n ? n[0] : an
  } function J(n, t) { return r(n, d(t), $n) } function M(n, t) { return $n(n, typeof t == "function" ? t : cn) } function P(n, t, r) { return e(n, d(t), r, 3 > arguments.length, $n) } function U(n, t) { var r; if (typeof t != "function") throw new TypeError("Expected a function"); return n = Un(n), function () { return 0 < --n && (r = t.apply(this, arguments)), 1 >= n && (t = an), r } } function V(n) {
    var t; if (typeof n != "function") throw new TypeError("Expected a function"); return t = In(t === an ? n.length - 1 : Un(t), 0), function () {
      for (var r = arguments, e = -1, u = In(r.length - t, 0), o = Array(u); ++e < u;)o[e] = r[t + e];
      for (u = Array(t + 1), e = -1; ++e < t;)u[e] = r[e]; return u[t] = o, n.apply(this, u)
    }
  } function H(n, t) { return n > t } function K(n) { return Y(n) && L(n) && En.call(n, "callee") && (!Rn.call(n, "callee") || "[object Arguments]" == kn.call(n)) } function L(n) { return null != n && !(typeof n == "function" && Q(n)) && W(zn(n)) } function Q(n) { return n = X(n) ? kn.call(n) : "", "[object Function]" == n || "[object GeneratorFunction]" == n } function W(n) { return typeof n == "number" && n > -1 && 0 == n % 1 && 9007199254740991 >= n } function X(n) {
    var t = typeof n; return !!n && ("object" == t || "function" == t);
  } function Y(n) { return !!n && typeof n == "object" } function Z(n) { return typeof n == "number" || Y(n) && "[object Number]" == kn.call(n) } function nn(n) { return typeof n == "string" || !Pn(n) && Y(n) && "[object String]" == kn.call(n) } function tn(n, t) { return t > n } function rn(n) { return typeof n == "string" ? n : null == n ? "" : n + "" } function en(n) { var t = C(n); if (!t && !L(n)) return Dn(Object(n)); var r, e = z(n), u = !!e, e = e || [], o = e.length; for (r in n) !En.call(n, r) || u && ("length" == r || f(r, o)) || t && "constructor" == r || e.push(r); return e } function un(n) {
    for (var t = -1, r = C(n), e = w(n), u = e.length, o = z(n), i = !!o, o = o || [], c = o.length; ++t < u;) {
      var a = e[t]; i && ("length" == a || f(a, c)) || "constructor" == a && (r || !En.call(n, a)) || o.push(a)
    } return o
  } function on(n) { return n ? u(n, en(n)) : [] } function cn(n) { return n } function fn(t, r, e) {
    var u = en(r), o = b(r, u); null != e || X(r) && (o.length || !u.length) || (e = r, r = t, t = this, o = b(r, en(r))); var i = X(e) && "chain" in e ? e.chain : true, c = Q(t); return $n(o, function (e) {
      var u = r[e]; t[e] = u, c && (t.prototype[e] = function () {
        var r = this.__chain__; if (i || r) {
          var e = t(this.__wrapped__); return (e.__actions__ = N(this.__actions__)).push({
            func: u, args: arguments,
            thisArg: t
          }), e.__chain__ = r, e
        } return u.apply(t, n([this.value()], arguments))
      })
    }), t
  } var an, ln = 1 / 0, pn = /[&<>"'`]/g, sn = RegExp(pn.source), hn = /^(?:0|[1-9]\d*)$/, vn = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" }, yn = { "function": true, object: true }, _n = yn[typeof exports] && exports && !exports.nodeType ? exports : an, gn = yn[typeof module] && module && !module.nodeType ? module : an, bn = gn && gn.exports === _n ? _n : an, jn = o(yn[typeof self] && self), mn = o(yn[typeof window] && window), dn = o(yn[typeof this] && this), wn = o(_n && gn && typeof global == "object" && global) || mn !== (dn && dn.window) && mn || jn || dn || Function("return this")(), On = Array.prototype, xn = Object.prototype, En = xn.hasOwnProperty, An = 0, kn = xn.toString, Nn = wn._, Sn = wn.Reflect, Tn = Sn ? Sn.f : an, Fn = Object.create, Rn = xn.propertyIsEnumerable, Bn = wn.isFinite, Dn = Object.keys, In = Math.max, $n = function (n, t) {
    return function (r, e) { if (null == r) return r; if (!L(r)) return n(r, e); for (var u = r.length, o = t ? u : -1, i = Object(r); (t ? o-- : ++o < u) && false !== e(i[o], o, i);); return r }
  }(g), qn = function (n) { return function (t, r, e) { var u = -1, o = Object(t); e = e(t); for (var i = e.length; i--;) { var c = e[n ? i : ++u]; if (false === r(o[c], c, o)) break } return t } }(); Tn && !Rn.call({ valueOf: 1 }, "valueOf") && (w = function (n) { n = Tn(n); for (var t, r = []; !(t = n.next()).done;)r.push(t.value); return r }); var zn = A("length"), Cn = V(function (t, r) {
    return Pn(t) || (t = null == t ? [] : [Object(t)]), _(r, 1),
      n(N(t), on)
  }), Gn = V(function (n, t, r) { return D(n, t, r) }), Jn = V(function (n, t) { return h(n, 1, t) }), Mn = V(function (n, t, r) { return h(n, Vn(t) || 0, r) }), Pn = Array.isArray, Un = Number, Vn = Number, Hn = R(function (n, t) { F(t, en(t), n) }), Kn = R(function (n, t) { F(t, un(t), n) }), Ln = R(function (n, t, r, e) { F(t, un(t), n, e) }), Qn = V(function (n) { return n.push(an, p), Ln.apply(an, n) }), Wn = V(function (n, t) { return null == n ? {} : E(n, _(t, 1)) }), Xn = d; l.prototype = s(a.prototype), l.prototype.constructor = l, a.assignIn = Kn, a.before = U, a.bind = Gn, a.chain = function (n) {
    return n = a(n),
      n.__chain__ = true, n
  }, a.compact = function (n) { return y(n, Boolean) }, a.concat = Cn, a.create = function (n, t) { var r = s(n); return t ? Hn(r, t) : r }, a.defaults = Qn, a.defer = Jn, a.delay = Mn, a.filter = function (n, t) { return y(n, d(t)) }, a.flatten = function (n) { return n && n.length ? _(n, 1) : [] }, a.flattenDeep = function (n) { return n && n.length ? _(n, ln) : [] }, a.iteratee = Xn, a.keys = en, a.map = function (n, t) { return O(n, d(t)) }, a.matches = function (n) { return x(Hn({}, n)) }, a.mixin = fn, a.negate = function (n) {
    if (typeof n != "function") throw new TypeError("Expected a function");
    return function () { return !n.apply(this, arguments) }
  }, a.once = function (n) { return U(2, n) }, a.pick = Wn, a.slice = function (n, t, r) { var e = n ? n.length : 0; return r = r === an ? e : +r, e ? k(n, null == t ? 0 : +t, r) : [] }, a.sortBy = function (n, t) {
    var r = 0; return t = d(t), O(O(n, function (n, e, u) { return { c: n, b: r++, a: t(n, e, u) } }).sort(function (n, t) {
      var r; n: { r = n.a; var e = t.a; if (r !== e) { var u = null === r, o = r === an, i = r === r, c = null === e, f = e === an, a = e === e; if (r > e && !c || !i || u && !f && a || o && a) { r = 1; break n } if (e > r && !u || !a || c && !o && i || f && i) { r = -1; break n } } r = 0 } return r || n.b - t.b;
    }), A("c"))
  }, a.tap = function (n, t) { return t(n), n }, a.thru = function (n, t) { return t(n) }, a.toArray = function (n) { return L(n) ? n.length ? N(n) : [] : on(n) }, a.values = on, a.extend = Kn, fn(a, a), a.clone = function (n) { return X(n) ? Pn(n) ? N(n) : F(n, en(n)) : n }, a.escape = function (n) { return (n = rn(n)) && sn.test(n) ? n.replace(pn, i) : n }, a.every = function (n, t, r) { return t = r ? an : t, v(n, d(t)) }, a.find = J, a.forEach = M, a.has = function (n, t) { return null != n && En.call(n, t) }, a.head = G, a.identity = cn, a.indexOf = function (n, t, r) {
    var e = n ? n.length : 0; r = typeof r == "number" ? 0 > r ? In(e + r, 0) : r : 0,
      r = (r || 0) - 1; for (var u = t === t; ++r < e;) { var o = n[r]; if (u ? o === t : o !== o) return r } return -1
  }, a.isArguments = K, a.isArray = Pn, a.isBoolean = function (n) { return true === n || false === n || Y(n) && "[object Boolean]" == kn.call(n) }, a.isDate = function (n) { return Y(n) && "[object Date]" == kn.call(n) }, a.isEmpty = function (n) { if (L(n) && (Pn(n) || nn(n) || Q(n.splice) || K(n))) return !n.length; for (var t in n) if (En.call(n, t)) return false; return true }, a.isEqual = function (n, t) { return j(n, t) }, a.isFinite = function (n) { return typeof n == "number" && Bn(n) }, a.isFunction = Q, a.isNaN = function (n) {
    return Z(n) && n != +n
  }, a.isNull = function (n) { return null === n }, a.isNumber = Z, a.isObject = X, a.isRegExp = function (n) { return X(n) && "[object RegExp]" == kn.call(n) }, a.isString = nn, a.isUndefined = function (n) { return n === an }, a.last = function (n) { var t = n ? n.length : 0; return t ? n[t - 1] : an }, a.max = function (n) { return n && n.length ? t(n, cn, H) : an }, a.min = function (n) { return n && n.length ? t(n, cn, tn) : an }, a.noConflict = function () { return wn._ === this && (wn._ = Nn), this }, a.noop = function () { }, a.reduce = P, a.result = function (n, t, r) {
    return t = null == n ? an : n[t],
      t === an && (t = r), Q(t) ? t.call(n) : t
  }, a.size = function (n) { return null == n ? 0 : (n = L(n) ? n : en(n), n.length) }, a.some = function (n, t, r) { return t = r ? an : t, S(n, d(t)) }, a.uniqueId = function (n) { var t = ++An; return rn(n) + t }, a.each = M, a.first = G, fn(a, function () { var n = {}; return g(a, function (t, r) { En.call(a.prototype, r) || (n[r] = t) }), n }(), { chain: false }), a.VERSION = "4.5.1", $n("pop join replace reverse split push shift sort splice unshift".split(" "), function (n) {
    var t = (/^(?:replace|split)$/.test(n) ? String.prototype : On)[n], r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", e = /^(?:pop|join|replace|shift)$/.test(n);
    a.prototype[n] = function () { var n = arguments; return e && !this.__chain__ ? t.apply(this.value(), n) : this[r](function (r) { return t.apply(r, n) }) }
  }), a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = function () { return T(this.__wrapped__, this.__actions__) }, (mn || jn || {})._ = a, typeof define == "function" && typeof define.amd == "object" && define.amd ? define(function () { return a }) : _n && gn ? (bn && ((gn.exports = a)._ = a), _n._ = a) : wn._ = a
}).call(this);
/*
 * Debounce function
 * based on unminified version from http://davidwalsh.name/javascript-debounce-function
 */
theme.debounce = function (n, t, u) { var e; return function () { var a = this, r = arguments, i = function () { e = null, u || n.apply(a, r) }, o = u && !e; clearTimeout(e), e = setTimeout(i, t), o && n.apply(a, r) } };

// https://gist.github.com/ionurboz/51b505ee3281cd713747b4a84d69f434
theme.throttle = function(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

// Add extra easings to jquery
$.extend($.easing, {
  // t: current time, b: begInnIng value, c: change In value, d: duration
	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},  
  easeInCubic: function (x, t, b, c, d) {
    return c*(t/=d)*t*t + b;
  },
  easeOutCubic: function (x, t, b, c, d) {
    return c*((t=t/d-1)*t*t + 1) + b;
  },
  easeInOutCubic: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t*t + b;
    return c/2*((t-=2)*t*t + 2) + b;
  },
});

/* ================ Cookies ================ */

/*! js-cookie v3.0.5 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));

theme.USER_COOKIES = {
  SUBSCRIBE_POPUP_SEEN: 'und_subscribe_popup_seen',
  SUBSCRIBE_COMPLETE: 'und_subscribe_complete'
}

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[.@]/
    );

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
              currentOption.name = $element.data('name');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val() || $element.find('option').filter(':selected').val(); // If an option is selected and disabled, $element.val() will return ''
            currentOption.index = $element.data('index');
            currentOption.name = $element.data('name');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    _triggerVariantChange: function () {
      var variant = this._getVariantFromOptions();
      var currentOptions = this._getCurrentOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        currentOptions: currentOptions
      });
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();
      var currentOptions = this._getCurrentOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        currentOptions: currentOptions
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      //this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     *
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },
    */
    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      // It's possible for currentVariant to not exist
      var currPrice = this.currentVariant && this.currentVariant.price;
      var currComparePrice = this.currentVariant && this.currentVariant.compare_at_price;

      if (variant.price === currPrice && variant.compare_at_price === currComparePrice) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant SKU changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      var skuz = this.currentVariant && this.currentVariant.sku;

      if (variant.sku === skuz) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


slate.ProductOption = (function ($) {
  var selectors = {
    singleOptionSelector: '.single-option-selector__radio',
    optionValueUI: '[data-option-value-ui][data-option-value]',
    labelValue: '[data-label-value]',
    optionLabel: '.single-option-radio__label'
  };

  var classes = {
    optionValueActive: 'is-active',
    optionValueDisabled: 'is-disabled'
  }  

  /**
   * ProductOption constructor
   *
   * @param { Object } product - Product instance
   * @param { jQuery } $el - Main element
   */
  function ProductOption(el) {
    this.$el = $(el);
    this.position = this.$el.data('position');
    this.name = this.$el.data('name');
    this.nameHandle = this.$el.data('name-handle');
    this.positionLabel = 'option' + this.position;
    this.$singleOptionSelector = $(selectors.singleOptionSelector, this.$el);
    this.$optionValueUIs = $(selectors.optionValueUI, this.$el)
    this.$valueOptions = this.$singleOptionSelector.find('option');
    this.$labelValue = $(selectors.labelValue, this.$el);

    this.$optionValueUIs.on('click', this.onOptionValueUIClick.bind(this))

    // a11y (P0-1): the option value UI is a custom control, so it needs to be
    // focusable and operable from the keyboard, and it needs to expose radio
    // semantics + selected/disabled state. The click path is untouched --
    // keyboard activation goes through the same handler.
    this.$optionValueGroup = this.$optionValueUIs.first().parent()
    this.$optionValueUIs.on('keydown', this.onOptionValueUIKeydown.bind(this))
    this._initA11y()
  }

  ProductOption.prototype = $.extend({}, ProductOption.prototype, {
    /**
     * A value is selectable if it isn't sold out. Swatches are the exception --
     * they stay clickable when disabled so the shopper can switch colourway.
     * This mirrors the guard in onOptionValueUIClick exactly.
     */
    _isSelectable: function ($valueUI) {
      return $valueUI.hasClass('swatch') || !$valueUI.hasClass(classes.optionValueDisabled)
    },

    _selectableOptionValueUIs: function () {
      var self = this
      return this.$optionValueUIs.filter(function (i, el) {
        return self._isSelectable($(el))
      })
    },

    /**
     * Roving tabindex: exactly one option per group is in the tab order.
     * Arrow keys move between the rest, per the radio group pattern.
     */
    _updateRovingTabIndex: function () {
      var $active = this.$optionValueUIs.filter('.' + classes.optionValueActive).first()
      var $selectable = this._selectableOptionValueUIs()
      var $entry = $active.length ? $active : $selectable.first()

      if (!$entry.length) {
        $entry = this.$optionValueUIs.first()
      }

      this.$optionValueUIs.attr('tabindex', '-1')
      $entry.attr('tabindex', '0')
    },

    _initA11y: function () {
      if (!this.$optionValueUIs.length) {
        return
      }

      var self = this
      var $label = $(selectors.optionLabel, this.$el)

      this.$optionValueGroup.attr('role', 'radiogroup')

      // Point the group at the visible label. The label's `for` targets the
      // hidden <select>, so without this the group has no accessible name.
      if ($label.length) {
        if (!$label.attr('id')) {
          var sectionId = this.$el.closest('[data-section-id]').attr('data-section-id') || 'product'
          $label.attr('id', 'ProductOptionLabel-' + sectionId + '-' + this.position)
        }
        this.$optionValueGroup.attr('aria-labelledby', $label.attr('id'))
      } else if (this.name) {
        this.$optionValueGroup.attr('aria-label', this.name)
      }

      this.$optionValueUIs.each(function (i, el) {
        var $valueUI = $(el)

        $valueUI.attr('role', 'radio')
        $valueUI.attr('aria-checked', $valueUI.hasClass(classes.optionValueActive) ? 'true' : 'false')

        if (!self._isSelectable($valueUI)) {
          $valueUI.attr('aria-disabled', 'true')
        }
      })

      this._updateRovingTabIndex()
    },

    _getValueOptionElForVal: function(value) {
      return this.$valueOptions.filter(function (i, el) {
        return $(el).val() === value
      }).first();
    },

    _getValueUIForVal: function(value) {
      return this.$optionValueUIs.filter('[data-option-value="'+ value +'"]').first()
    },    

    updateSelectedStateForValue: function (selectedValue) {
      // <option />
      this.$valueOptions.each(function (i, opt) {
        var $opt = $(opt);
        var val = $opt.val();

        if (val === selectedValue || val === '' && selectedValue === null) {
          $opt.attr('selected', true);
        }
        else {
          $opt.attr('selected', false);
        }
      })

      // alt UI
      const $valueUI = this._getValueUIForVal(selectedValue)

      this.$optionValueUIs.removeClass(classes.optionValueActive)
      $valueUI.addClass(classes.optionValueActive)

      // a11y: keep the exposed state in step with the class-based state
      this.$optionValueUIs.attr('aria-checked', 'false')
      $valueUI.attr('aria-checked', 'true')
      this._updateRovingTabIndex()
      
      // Update label
      this.$labelValue.text(selectedValue)
    },

    updateOptionValueAvailability: function (value, available) {
      var $el = this._getValueOptionElForVal(value); // <option>
      var $valueUI = this._getValueUIForVal(value); // .swatch, etc..
      var unavailable = !available;
      var text = value;
      var disabledProp = false;

      // Only disable the option if the value isn't color *and* it's sold out *and* there are multiple option values (otherwise you can't select others)
      if (this.nameHandle !== 'color' && unavailable && this.$valueOptions.length > 1) {
        disabledProp = 'disabled'
      }

      if (unavailable) {
        text += ' - SOLD OUT';
      }

      $el
        .prop('disabled', disabledProp)
        .attr('aria-disabled', disabledProp ? 'true' : null)
        .text(text);

      $valueUI.toggleClass(classes.optionValueDisabled, !available)

      // a11y: sold-out values are announced as unavailable rather than as
      // ordinary, selectable options
      if (this._isSelectable($valueUI)) {
        $valueUI.removeAttr('aria-disabled')
      } else {
        $valueUI.attr('aria-disabled', 'true')
      }

      this._updateRovingTabIndex()
    },

    onOptionValueUIClick: function(evt) {
      const $target = $(evt.currentTarget)
      const value = $target.data('option-value')
      const isSwatch = $target.hasClass('swatch')
      const isDisabled = $target.hasClass('is-disabled')

      // Swatches are always clickable
      if (this.$singleOptionSelector.val() === value || (isDisabled && !isSwatch)) {
        return
      }

      this.$singleOptionSelector
        .val(value)
        .trigger('change')
    },

    /**
     * Keyboard support for the option value UI (WCAG 2.1.1).
     *
     * Enter / Space  - select the focused value
     * Arrows         - move to the previous/next selectable value and select it,
     *                  matching native radio group behaviour (sold-out values
     *                  are skipped, exactly as a disabled radio would be)
     * Home / End     - jump to the first/last selectable value
     */
    onOptionValueUIKeydown: function (evt) {
      var key = evt.key
      var $target = $(evt.currentTarget)

      if (key === ' ' || key === 'Spacebar' || key === 'Enter') {
        evt.preventDefault()
        $target.trigger('click')
        return
      }

      var toPrev = key === 'ArrowLeft' || key === 'Left' || key === 'ArrowUp' || key === 'Up'
      var toNext = key === 'ArrowRight' || key === 'Right' || key === 'ArrowDown' || key === 'Down'
      var toFirst = key === 'Home'
      var toLast = key === 'End'

      if (!toPrev && !toNext && !toFirst && !toLast) {
        return
      }

      var $selectable = this._selectableOptionValueUIs()

      if ($selectable.length < 2) {
        return
      }

      evt.preventDefault()

      var currentIndex = $selectable.index($target)
      var nextIndex

      if (toFirst) {
        nextIndex = 0
      } else if (toLast) {
        nextIndex = $selectable.length - 1
      } else if (currentIndex === -1) {
        // focus sat on a sold-out value; step in from the appropriate end
        nextIndex = toPrev ? $selectable.length - 1 : 0
      } else if (toPrev) {
        nextIndex = (currentIndex - 1 + $selectable.length) % $selectable.length
      } else {
        nextIndex = (currentIndex + 1) % $selectable.length
      }

      var $next = $selectable.eq(nextIndex)

      this.$optionValueUIs.attr('tabindex', '-1')
      $next.attr('tabindex', '0')
      $next.trigger('focus')
      $next.trigger('click')
    },
  });

  return ProductOption;
})(jQuery);

slate.ProductForm = (function ($) {
  var selectors = {
    productJSON: '[data-product-json]',
    productForm: '.add-to-cart__form',
    productOption: '[data-product-option]',
    addToCart: '.btn--add-to-cart',
    addToCartText: '.btn__text',
    priceContainer: '[data-price-container]',
    productPrice: '#ProductPrice',
    SKU: '.variant-sku',
    priceA11y: '#PriceA11y',
    comparePrice: '#ComparePrice',
    comparePriceA11y: '#ComparePriceA11y',
    comparePriceWrapper: '.product-single__price--wrapper',
    quantityElements: '.js-quantity-selector, label + .js-qty',
    originalSelectorId: '[data-variant-select]',
    singleOptionSelector: '.single-option-selector__radio',
    colorSelect: 'select.color-select',
    meta: '.product-single__meta',
    productWrapper: '.product-single',
    shopifyPaymentButton: '.shopify-payment-button',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]'
  };

  var classes = {
    priceContainerUnitAvailable: 'price-container--unit-available'
  };

  /**
   * ProductForm constructor
   *
   * @param { jQuery } $el - Main element
   * @param { Object } options - options object
   */
  function ProductForm(container, options) {
    this.$container = $(container);
    this.productSingleObject = JSON.parse($(selectors.productJSON, this.$container).html());

    var defaults = {
      onColorSelectChange: $.noop,
      onRaffleModeSubmit: $.noop,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      namespace: '.productSection',
      staticSku: !!this.$container.data('static-sku')
    };

    // this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.availableVariants = $.map(this.productSingleObject.variants, function (variant) {
      if (variant.available) {
        return variant;
      }
    })

    this.settings = $.extend({}, defaults, options);

    this.submitInProgress = false;

    this.$addToCart = $(selectors.addToCart, this.$container);
    this.$addToCartText = $(selectors.addToCartText, this.$container);
    this.$addToCartForm = $('form[action="/cart/add"]', this.$container);
    this.$priceContainer = $(selectors.priceContainer, this.$container);
    this.$productPrice = $(selectors.productPrice, this.$container);
    this.$priceA11y = $(selectors.priceA11y, this.$container);
    this.$comparePrice = $(selectors.comparePrice, this.$container);
    this.$comparePriceWrapper = $(selectors.comparePriceWrapper, this.$container);
    this.$comparePriceA11y = $(selectors.comparePriceA11y, this.$container);
    this.$unitPrice = $(selectors.unitPrice, this.$container);
    this.$unitPriceBaseUnit = $(selectors.unitPriceBaseUnit, this.$container);
    this.$sku = $(selectors.SKU, this.$container);
    this.$colorSelect = $(selectors.colorSelect, this.$container);
    this.$quantityElements = $(selectors.quantityElements, this.$container);
    this.$shopifyPaymentButton = $(selectors.shopifyPaymentButton, this.$container);

    this.productOptions = $.map($(selectors.productOption, this.$container), function (el, i) {
      return new slate.ProductOption(el);
    });

    this.raffleMode = this.$addToCartForm.data('raffle-mode') || false;
    this.variants = new slate.Variants({
      $container: this.$container,
      enableHistoryState: this.settings.enableHistoryState,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    });

    // Override defaults in theme.strings with potential template overrides
    theme.productStrings = theme.productStrings || {};
    $.extend(theme.strings, theme.productStrings);

    this.$container.on('variantChange' + this.settings.namespace, this.onVariantChange.bind(this));
    this.$colorSelect.on('change', this.onColorSelectChange.bind(this));

    this.variants._triggerVariantChange();
    this.$colorSelect.trigger('change');

    this.$addToCartForm.on('submit', this.onAddToCartFormSubmit.bind(this));
  }

  ProductForm.prototype = _.assignIn({}, ProductForm.prototype, {
    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Array} currentOptions - Array of options
     * @param {Object} [option]
     * @param {String} option.name  - i.e. "Color"
     * @param {String} option.value - i.e. "Gun Metal"
     */
    updateOptionValues: function (currentOptions) {
      var self = this;

      currentOptions.forEach(function (currentOption) {
        var productOption = self.productOptions.find(function (pO) {
          return pO.name === currentOption.name
        });

        productOption && productOption.updateSelectedStateForValue(currentOption.value);
      });

      // Recursive function to check option values for variant availability
      // Goes deeper until we run out of product options
      function checkOption(optionIndex, availableVariantsArray) {
        var position = optionIndex + 1
        var positionName = 'option' + position;
        var product = self.productSingleObject
        var optionWithValues = product.options_with_values[optionIndex];
        var optionName = optionWithValues.name;

        var productOption = self.productOptions.find(function (pO) {
          return pO.name === optionName;
        });

        optionWithValues.values.forEach(function (value) {
          var availableVariantsForValue = availableVariantsArray.filter(function (variant) {
            return variant[positionName] === value && variant.available;
          });

          var available = availableVariantsForValue.length > 0

          productOption && productOption.updateOptionValueAvailability(value, available);

          // If our loop is on a currently selected option and we can go deeper...
          if (currentOptions[optionIndex] &&
            currentOptions[optionIndex].value === value &&
            product.options_with_values[optionIndex + 1]
          ) {
            checkOption(optionIndex + 1, availableVariantsForValue)
          }
        });
      }

      checkOption(0, self.availableVariants)
    },

    /**
     * Updates the DOM state of the add to cart button based on the currently selected variant and options
     *
     * @param {Object} variant
     */
    updateAddToCartState: function (variant) {
      var translations = theme.strings;

      if (this.productSingleObject.available === false) {
        this.$addToCart.addClass('disabled').prop('disabled', true);
        this.$addToCartText.html(translations.soldOut);
        this.$quantityElements.hide();
        this.$shopifyPaymentButton.hide();
        return
      }

      if (variant) {
        if (variant.available) {
          // Available, enable the submit button, change text, show quantity elements
          this.$addToCart.removeClass('disabled').prop('disabled', false);
          this.$addToCartText.html(this.raffleMode ? (theme.strings.enterRaffle || 'Enter Raffle') : translations.addToCart);

          if (!this.raffleMode) {
            this.$quantityElements.show();
            this.$shopifyPaymentButton.show();
          }
        }
        else {
          // Sold out, disable the submit button, change text, hide quantity elements
          this.$addToCart.addClass('disabled').prop('disabled', true);
          this.$addToCartText.html(translations.soldOut);
          this.$quantityElements.hide();
          this.$shopifyPaymentButton.hide();
        }

        if (!this.settings.staticSku) {
          this.$sku.html(variant.sku);  // Update Sku
        }
      }
      else {
        this.$addToCart.addClass('disabled').prop('disabled', true);
        this.$addToCartText.html(translations.unavailable); // 'Select an option'
        this.$quantityElements.hide();
        this.$shopifyPaymentButton.hide();
      }
    },

    getSelectedColorValue() {
      return this.$colorSelect.val() && this.$colorSelect.val().replace(/\s/g, '').toLowerCase();
    },

    updatePrice: function (variant) {
      var moneyFormat = theme.strings.moneyFormat;
      var ariaHiddenPrice = 'false'; // Do we need to hide the 
      var ariaHiddenCompare = 'false';

      if (variant) {
        this.$productPrice
          .html(theme.Currency.formatMoney(variant.price, moneyFormat))
          .show();

        this.$priceContainer.removeClass('visibility-hidden ' + classes.priceContainerUnitAvailable);

        ariaHiddenPrice = 'false';

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          this.$comparePrice.html(theme.Currency.formatMoney(variant.compare_at_price, moneyFormat));
          this.$comparePriceWrapper.removeClass('hide');
          this.$productPrice.addClass('on-sale');

          ariaHiddenCompare = 'false';
        } else {
          this.$comparePriceWrapper.addClass('hide')
          this.$comparePrice.html('');
          this.$productPrice.removeClass('on-sale');

          ariaHiddenCompare = 'true';
        }

        if (variant.unit_price) {
          this.$unitPrice.html(theme.Currency.formatMoney(variant.unit_price, moneyFormat));
          this.$unitPriceBaseUnit.html(this.getBaseUnit(variant));
          this.$priceContainer.addClass(classes.priceContainerUnitAvailable);
        }
      }
      else {
        ariaHiddenPrice = 'true';
        ariaHiddenCompare = 'true';
      }

      this.$productPrice.attr('aria-hidden', ariaHiddenPrice);
      this.$priceA11y.attr('aria-hidden', ariaHiddenPrice);
      this.$comparePriceWrapper.attr('aria-hidden', ariaHiddenCompare);
      this.$comparePriceA11y.attr('aria-hidden', ariaHiddenCompare);
    },

    onAddToCartFormSubmit: function (evt) {
      if (this.raffleMode) {
        evt.preventDefault();
        this.settings.onRaffleModeSubmit(evt);
        return false;
      }

      if (this.submitInProgress) {
        return false;
      }

      evt.preventDefault();

      const textElHeight = this.$addToCartText.height();
      const textElContent = this.$addToCartText.html();
      
      this.$addToCart.prop('disabled', true);
      this.$addToCartText.css('height', textElHeight);
      this.$addToCartText.html('Adding<br>To Cart...');
      
      this.submitInProgress = true;

      CartAPI.addItemFromForm(this.$addToCartForm.get(0))
        .then(cart => {
          // console.log('onAdd Success', cart);
        })
        .catch(error => {
          console.error('onAdd Error', error);
          // @TODO - Add to status?
        })
        .finally(() => {
          this.$addToCart.prop('disabled', false);
          this.$addToCartText.html(textElContent);
          this.$addToCartText.css('height', '');
          this.submitInProgress = false;
        });
    },

    onColorSelectChange: function () {
      var val = this.getSelectedColorValue();
      this.settings.onColorSelectChange(val);
    },

    onVariantChange: function (evt) {
      var variant = evt.variant;
      var currentOptions = evt.currentOptions;

      this.updatePrice(variant)
      this.updateOptionValues(currentOptions);
      this.updateAddToCartState(variant, currentOptions);
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    },

    getBaseUnit: function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }
  });

  return ProductForm;
})(jQuery);

slate.DetailViewer = (function($) {
  var classes = {
    bodyViewerOpen: 'detail-viewer-open'
  };

  function DetailViewer(container) {
    this.$container = $(container);

    this.aspectRatio = null;
    this.isVerticalScroll = false; // flag so we know if we're the detail images scroll vertically or horizontally
    this.activeZoomIndex = -1;

    this.$detailViewer = $('.product-single__detail-viewer', this.$container);
    this.$detailViewerList = $('.product-single__detail-viewer-list', this.$detailViewer);
    this.$detailViewerItems = this.$detailViewerList.find('.product-single__detail-viewer-item');
    this.$detailViewerImages = this.$detailViewerList.find('img');
    this.$owlDots = this.$detailViewer.find('.owl-dot');

    this.$detailViewerImages.css('cursor', 'zoom-out');

    this.$owlDots.on('click', this.onDotClick.bind(this));
    this.$detailViewerList.on('scroll', theme.throttle(this.onScroll.bind(this), 150)); // Since this is just updating the active dot, it doesn't need to fire very often
    this.$detailViewerImages.on('click', this.onImageClick.bind(this));
    $(window).on('resize', theme.throttle(this.onResize.bind(this), 150));

    this.onResize();
  }

  DetailViewer.prototype = _.assignIn({}, DetailViewer.prototype, {
    // 'center' is only disabled if 'false' is explicitly passed
    scrollToItem($item, center) {
      if (!$item || $item.length === 0) return

      var item = $item.get(0)
      var itemRect = item.getBoundingClientRect();

      var top = this.isVerticalScroll ? this.$detailViewerList.scrollTop() + itemRect.top : 0;
      var left = this.isVerticalScroll ? 0 : this.$detailViewerList.scrollLeft() + itemRect.x;      

      if (center !== false) {
        if (this.isVerticalScroll) {
          top += (item.clientHeight - window.innerHeight)/2;
        }
        else {
          left += (item.clientWidth - window.innerWidth)/2;
        }
      }

      animateScrollTo([left, top], {
        elementToScroll: this.$detailViewerList.get(0),
        minDuration: 400,
        maxDuration: 700,
        speed: 300,
        easing: function(t) { return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1 }
      });
    },

    open(imageId) {
      this.$detailViewer.fadeIn({
        start: function() {
          $(document.body).addClass(classes.bodyViewerOpen);
        },
        done: function() {
          if (imageId) {
            var $goToItem = this.$detailViewerImages.filter('[data-image-id="'+imageId+'"]').first().parent()

            this.scrollToItem($goToItem);
          }
        }.bind(this)
      });

      this.$detailViewerList.get(0).scrollTo({
        top: 0,
        left: 0
      });

      setTimeout(this.setActiveItem.bind(this), 50);
    },

    close() {
      this.$detailViewer.fadeOut({
        start: function() {
          $(document.body).removeClass(classes.bodyViewerOpen);
        }
      });
    },

    filter(color) {      
      if (color && color != '-') {
        this.$detailViewerItems.hide();
        this.$owlDots.hide();

        this.$detailViewerItems.filter('[data-variant="' + color + '"]').show();   
        this.$owlDots.filter('[data-variant="' + color + '"]').show();    
      }
      else {
        this.$detailViewerItems.show();
        this.$owlDots.show();
      }
    },

    setActiveItem() {
      var midPointH = window.innerWidth / 2
      var midPointV = window.innerHeight / 2

      this.$detailViewerItems.each(function(i, el) {
        var rect = el.getBoundingClientRect()
        var rectLeft = rect.x
        var rectRight = rectLeft + rect.width
        var rectTop = rect.y
        var rectBottom = rectTop + rect.height
        var isCurrent = false      

        if (this.isVerticalScroll) {
          if (rectTop < midPointV && rectBottom > midPointV) {
            isCurrent = true
          }
        }
        else {
          if (rectLeft < midPointH && rectRight > midPointH) {
            isCurrent = true
          }          
        }

        if (isCurrent) {
          if (this.activeZoomIndex !== i) {
            this.activeZoomIndex = i
            this.$owlDots.removeClass('active')
            this.$owlDots.eq(i).addClass('active')
          }

          return false
        }
      }.bind(this))
    },

    onResize() {
      var aspectRatio = window.innerWidth / window.innerHeight

      if (aspectRatio > 1 && (!this.aspectRatio || this.aspectRatio < 1)) {
        this.$detailViewer.addClass('is-vertical');
        this.isVerticalScroll = true;
      }
      else if (aspectRatio < 1 && (!this.aspectRatio || this.aspectRatio > 1)) {
        this.$detailViewer.removeClass('is-vertical');
        this.isVerticalScroll = false;
      }

      this.aspectRatio = aspectRatio;

      this.setActiveItem();
    },

    onScroll() {
      this.setActiveItem();
    },

    onImageClick() {
      this.close();
    },

    onDotClick(e) {
      var $button = $(e.currentTarget)
      var index = $button.index()

      if (index === this.activeZoomIndex) return

      this.scrollToItem(this.$detailViewerItems.eq(index))
    }
  })

  return DetailViewer;
})(jQuery)

slate.ProductGallery = (function ($) {
  var selectors = {
    productImages: '.product-single__photos',
    productImageWrapper: '.product-single__photo-wrapper',
    productImagePhotoFlexWrapper: '.product-single__photo--flex-wrapper',
    productImagePhoto: '.product-single__photo'
  };

  var classes = {
    owlCarousel: 'owl-carousel owl-theme',
    zoomEnabled: 'zoom-enabled'
  };

  var $window = $(window);
  var desktopBpMin = 992;

  /**
   * ProductGallery constructor
   *
   * @param { jQuery } $el - Main element
   */
  function ProductGallery(container, options) {
    this.$container = $(container);

    var defaults = {
      responsive: true,
    };

    this.settings = $.extend({}, defaults, options);

    this.zoomEnabled = this.$container.data('image-zoom-type');
    this.carousel = null; // owlcarousel instance
    this.color = null;

    this.$productFlexWrapper = $(selectors.productImagePhotoFlexWrapper, this.$container);
    this.$productImages = $(selectors.productImages, this.$container);

    if (this.settings.responsive) {
      enquire.register(theme.variables.mediaQuerySmallZOR, {
        match: function() {
          this.createImageCarousel();
        }.bind(this),
        unmatch: function() {
          this.destroyImageCarousel();
        }.bind(this)
      });
    }
    else {
      this.createImageCarousel();
    }

    this.detailViewer = new slate.DetailViewer(this.$container);

    if (this.zoomEnabled === false) return

    this.$productFlexWrapper.addClass(classes.zoomEnabled);
    
    this.$container.on('click', selectors.productImagePhoto, function (e) {
      var imgId = $(e.currentTarget).data('image-id');

      this.detailViewer.open(imgId);
    }.bind(this))
  }

  ProductGallery.prototype = _.assignIn({}, ProductGallery.prototype, {
    filterImages() {
      if (this.color && this.color != '-') {
        if (this.settings.responsive && $window.width() > desktopBpMin) {
          this.$productFlexWrapper.hide();
          this.$productFlexWrapper.filter('[data-variant="' + this.color + '"]').fadeIn('slow');
        }
      }      
    },    

    filterCarousel: function () {
      if (this.carousel === null || this.carousel === undefined) return;

      var filter = '*';

      if (this.color && this.color != '-') {
        filter = '[data-variant="' + this.color + '"]';
      }

      this.$productImages.fadeTo(250, 0.01, function () {
        this.carousel.owlcarousel2_filter(filter);

        // Make dots accessible
        this.carousel.find('.owl-dot').each(function(i, el) {
          var $label = $('<label></label>').addClass('hidden-label').html('Gallery image ' + (i+1))
          $(el).append($label)
        })

        this.$productImages.fadeTo(250, 1);
      }.bind(this));
    },

    createImageCarousel: function () {
      this.$productImages.addClass(classes.owlCarousel);

      this.carousel = this.$productImages.owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        items: 1
      });

      this.$productFlexWrapper.show();
      this.filterCarousel();
    },

    destroyImageCarousel: function () {
      if (this.$productImages.length === 0) {
        return;
      }

      this.$productFlexWrapper.show();

      if ($window.width() >= desktopBpMin && this.$productImages.hasClass(classes.owlCarousel)) {
        if (this.carousel) {
          this.$productFlexWrapper.hide();
          this.carousel.owlcarousel2_filter('*')
          this.carousel.owlCarousel('destroy');
          this.$productImages.removeClass(classes.owlCarousel);
          this.carousel = null;
        }

        setTimeout(function () {
          // Destroy removes the dom elements I think?
          // We need to reset this instance var
          this.$productFlexWrapper = $(selectors.productImagePhotoFlexWrapper, this.$container);

          this.$productFlexWrapper.hide();

          setTimeout(function () {
            if (this.color && this.color != '-') {
              this.$productFlexWrapper.filter('[data-variant="' + this.color + '"]').fadeIn('slow');
            }
            else {
              this.$productFlexWrapper.fadeIn('slow');
            }
          }.bind(this), 200);
        }.bind(this), 25);
      }
    },

    onColorSelectChange: function (val) {
      this.color = val;

      this.filterImages();
      this.filterCarousel();
      this.detailViewer.filter(this.color);
    }
  });

  return ProductGallery;
})(jQuery);

slate.KlaviyoAPI = (function($) {
  const companyId = window.theme.klaviyo && window.theme.klaviyo.companyId
  const listId = window.theme.klaviyo && window.theme.klaviyo.listId
  
  if (!companyId) {
    console.warn('[KlaviyoAPI] - Klaviyo company ID not found')
  }
  
  if (!listId) {
    console.warn('[KlaviyoAPI] - Klaviyo list ID not found')
  }
  
  const KlaviyoAPI = {
    async makeRequest(path, data) {
      try {
        const response = await fetch(`https://a.klaviyo.com${path}?company_id=${companyId}`, {
          method: 'POST',
          headers: {
            'revision': '2024-07-15',
            'content-type': 'application/json',
            'cache-control': 'no-cache'
          },
          body: JSON.stringify(data)
        })
  
        const success = response.ok || response.status === 202 // The new Klaviyo API endpoints don't return any data in the response
  
        return success
      } catch (error) {
        return {
          message: 'Something went wrong',
          errors: [error.message]
        }
      }
    },
  
    // See: https://developers.klaviyo.com/en/reference/create_client_subscription
    createClientSubscription({ email, source }) {
      // Email and List ID are requred
      if (!email || !listId) {
        return 
      }
  
      const profileAttributes = {
        email
      }
  
      const data = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || null,
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      }
      
      return this.makeRequest('/client/subscriptions', data)
    }  
  }

  return KlaviyoAPI
})($);

/**
 * AJAX Klaviyo Library
 * -----------------------------------------------------------------------------
 * Handles AJAX form submission and callback event
 *
 * Usage:
 *
 *   var $form = $('form');
 *   var listId = $form.data('list-id');
 *   var source = $form.data('source');
 *
 *   var options = {
 *     listId: listId,
 *     source: source,
 *     onSubscribeSuccess: function() { .. },
 *     onSubmitFail: function(){ .. }
 *   };
 *
 *   var ajaxKlaviyoForm = new slate.AjaxKlaviyoForm($form, options);
 *
 * @namespace ajaxKlaviyoForm
 */
slate.AjaxKlaviyoForm = (function($) {

  /**
   * AJAX Klaviyo Form Constructor
   *
   * @param {HTMLElement | jQuery} form - Form element
   * @param {Object} options
   * @param {String} options.listId - Klaviyo List ID
   * @param {String} options.source - Klaviyo custom $source property
   * @param {Function} options.onInit
   * @param {Function} options.onBeforeSend - Prevent AJAX submission by returning false here
   * @param {Function} options.onSubmitFail  
   * @param {Function} options.onSubscribeSuccess
   * @param {Function} options.onSubscribeFail
   * @return {self}
   */
   function AjaxKlaviyoForm(form, options) {
 
     this.name = 'ajaxKlaviyoForm'
     this.namespace = '.' + this.name;
     this.events = {
       SUBMIT: 'submit' + this.namespace
     };
 
     var _this = this;
     var defaults = {
       source: "Shopify Form",
       onInit: $.noop,
       onBeforeSend: $.noop,
       onSubmitFail: $.noop,
       onSubscribeSuccess: $.noop,
       onSubscribeFail: $.noop
     };
 
     if (form.length === 0) {
       return false;
     }
 
     this.$form    = form instanceof jQuery ? form : $(form);
     this.$input   = this.$form.find('input[type="email"]');
     this.$submit  = this.$form.find('[type="submit"]');
     this.settings = $.extend({}, defaults, options);
     this.isSubmitting = false;
 
     this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));
 
     this.settings.onInit();
   };
 
   AjaxKlaviyoForm.prototype = $.extend({}, AjaxKlaviyoForm.prototype, {
     onBeforeSend: function() {
       if(this.settings.onBeforeSend() == false) {
         return false;
       }
 
       if (this.$input.val() && this.$input.val().length) {
         this.$submit.prop('disabled', true);
         this.isSubmitting = true;
 
         return true;
       }
       
       this.$input.parents('.form-group').addClass('alert-info');
 
       return false;
     },
     onSubmitDone: function(success) {
       this.$submit.prop('disabled', false);
 
       if(success) {
         this.settings.onSubscribeSuccess();
       }
       else {
         this.settings.onSubscribeFail();
       }
     },
     onSubmitFail: function(errors) {
       this.$submit.prop('disabled', false);
 
       if(errors instanceof Array && errors.length) {
         for (var i = errors.length - 1; i >= 0; i--) {
           console.warn('['+this.name+'] - onSubmitFail error: "' + errors[i] + '"');
         }
       }
       this.settings.onSubmitFail(errors);
     },
     onFormSubmit: async function(e) {
      e.preventDefault();

      if (this.onBeforeSend() === false) {
        return false;
      }

      try {
        const success = await slate.KlaviyoAPI.createClientSubscription({ email: this.$input.val(), source: this.settings.source })

        this.onSubmitDone(success);
      }
      catch ({ errors }) {
        this.onSubmitFail(errors)
      }
      finally {
        this.isSubmitting = false;
      }
 
       return false;
     }
   });
 
   return AjaxKlaviyoForm;
 })(jQuery);


slate.SubscribeForm = (function ($) {
  var selectors = {
    form: 'form[data-subscribe-form]',
    formSuccessMessage: '[data-form-success-message]',
    formErrorMessage: '[data-form-error-message]'
  };

  /**
   * SubscribeForm constructor
   *
   * @param { jQuery } el - Main element
   */
  function SubscribeForm(el, options = {}) {
    var defaults = {
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop,
      onSuccessAnimationComplete: $.noop
    };

    this.settings = $.extend({}, defaults, options);

    var $el        = $(el);

    this.$form       = $el.is(selectors.form) ? $el : $el.find(selectors.form).first();
    this.$successMessage = $(selectors.formSuccessMessage, this.$form);
    this.$errorMessage = $(selectors.formErrorMessage, this.$form);
    this.$emailInput = $('input[type="email"]', this.$form);

    this.messageFail = this.$form.data('message-fail') || 'Something went wrong.  Check your email and try again';
    this.messageAlreadySubscribed = this.$form.data('message-already-subscribed') || 'This email is already subscribed';
    
    if (this.$form.length === 0) {
      console.warn('Valid form element required to initialize');
      return;
    }

    this.ajaxForm = new slate.AjaxKlaviyoForm(this.$form, {
      source: this.$form.data('source'),
      onSubmitFail: this.onSubmitFail.bind(this),
      onSubscribeFail: this.onSubscribeFail.bind(this),
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this)      
    })
    
    this.$emailInput.on('keydown', this.onEmailInputKeydown.bind(this))
  }

  SubscribeForm.prototype = _.assignIn({}, SubscribeForm.prototype, {
    reset() {
      this.$errorMessage.text('');
      this.$errorMessage.hide();
      this.$emailInput.val('');
      this.$successMessage.hide();
    },
    onSubmitFail() {
      this.$errorMessage.text(this.messageFail);
      this.$errorMessage.show();
      this.settings.onSubmitFail();
    },
    onSubscribeFail(msg = '') {  
      this.$errorMessage.text(msg.match(/already subscribed/) ? this.messageAlreadySubscribed : this.messageFail);
      this.$errorMessage.show();
      this.settings.onSubscribeFail();
    },
  
    onSubscribeSuccess() {
      this.$successMessage.show();

      setTimeout(function() {
        this.settings.onSuccessAnimationComplete();
        this.reset()
      }.bind(this), 4000);

      Cookies.set(theme.USER_COOKIES.SUBSCRIBE_COMPLETE, true) // Forever cookie

      this.settings.onSubscribeSuccess();
    },
    onEmailInputKeydown() {
      this.$errorMessage.hide();
    }
  });

  return SubscribeForm;
})(jQuery);

/* ================ MODULES ================ */

var CartAPI = {
  EVENTS: {
    UPDATE: 'cartAPI.update',
    ADD: 'cartAPI.add',
    CHANGE: 'cartAPI.change', // WHen a single item quantity is changed (not removed)
    REMOVE: 'cartAPI.remove'
  },

  routes: window.theme.routes,

  dispatch(eventName, cart) {
    window.dispatchEvent(new CustomEvent(eventName, { bubbles: true, cancelable: true, detail: { cart } }));
  },

  async getResponseJSON(response) {
    let data = await response.text()

    // Theme editor adds HTML comments to JSON response, strip these
    data = data.replace(/<\/?[^>]+>/gi, '')

    return JSON.parse(data)
  },

  /**
   * Retrieve a JSON respresentation of the users cart
   *
   * @return {Promise} - JSON cart
   */
  async getCart() {
    try {
      const response = await fetch(`${this.routes.cart_url}?view=json`, {
        method: 'GET',
      })

      const cart = await this.getResponseJSON(response)

      return cart
    }
    catch (e) {
      throw new Error('Could not retrieve cart items', e);
    }
  },

  /**
   * Retrieve a JSON object of upsells items for the users cart
   *
   * @return {Promise} - JSON cart
   */
  async getCartUpsells() {
    try {
      const response = await fetch(`${this.routes.cart_url}?view=upsells-json`, {
        method: 'GET',
      })

      const upsells = await this.getResponseJSON(response)

      return upsells     
    }
    catch (e) {
      throw new Error('Could not retrieve cart upsells', e);
    }
  },

  /**
   * AJAX submit an 'add to cart' form
   *
   * @param {HTMLFormElement} form - The form element
   * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
   */
  async addItemFromForm(form) {
    try {
      const formData = new FormData(form)
      const body = new URLSearchParams([...formData].filter(([_, value]) => value !== '' && value != null)) // Remove empty values
  
      const response = await fetch(`${this.routes.cart_add_url}.js`, {
        method: 'POST',
        body,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
  
      if (!response.ok) {
        throw new Error('The quantity you entered is not available.')
      }

      let addedItem = await response.text()
          addedItem = JSON.parse(addedItem) || {};

      const cart = await this.getCart() // Retrieve the updated cart

      this.dispatch(CartAPI.EVENTS.UPDATE, cart)
      this.dispatch(CartAPI.EVENTS.ADD, { ...cart, added_item: addedItem }) // This is the only one that has the extra "addedItem" property
      
      return cart
    }
    catch (error) {
      throw new Error(error.message || 'An error occurred while adding the item to the cart.');

      /*
        @TODO - Add fail event - something like this:
        
        const event = new CustomEvent(events.ADD_FAIL, { detail: {
          message: data.message,
          description: data.description,
          relatedTarget: form
        }})

        window.dispatchEvent(event)
      */
    }
  },

  /**
   * Change the quantity of an item in the users cart
   * Item is specified by line_item key
   * https://shopify.dev/api/ajax/reference/cart#post-locale-cart-change-js
   *
   * @param {String} id - Cart line item id // https://shopify.dev/docs/api/liquid/objects/line_item#line_item-id
   * @param {Integer} qty - New quantity of the variant
   * @return {Promise} - JSON cart
   */
  async changeLineItemQuantity(id, qty) {
    try {
      const response = await fetch(`${this.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `quantity=${qty}&id=${id}`,
      })

      if (!response.ok) {
        throw new Error('Something went wrong.')
      }

      const cart = await this.getCart() // Retrieve the updated cart

      const EVENT = qty === 0 ? CartAPI.EVENTS.REMOVE : CartAPI.EVENTS.CHANGE
      
      this.dispatch(EVENT, cart)
      this.dispatch(CartAPI.EVENTS.UPDATE, cart)  

      return cart
    }
    catch (error) {
      return Promise.reject({ message: error.message })
    }
  },

  async clearCart() {
    try {
      const response = await fetch(`${this.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }        
      })

      if (!response.ok) {
        throw new Error('Something went wrong.')
      }

      const cart = await this.getCart() // Retrieve the updated cart

      this.dispatch(CartAPI.EVENTS.UPDATE, cart)  

      return cart
    }
    catch (error) {
      return Promise.reject({ message: error.message })
    }
  },
}

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
timber.initCache = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    $window: $(window),

    // Navigation
    $navigation: $('#AccessibleNav'),

    // Product Page
    $optionSelector: $('.single-option-selector'),

    // Customer Pages
    $recoverPasswordLink: $('#RecoverPassword'),
    $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
    $recoverPasswordForm: $('#RecoverPasswordForm'),
    $customerLoginForm: $('#CustomerLoginForm'),
    $passwordResetSuccess: $('#ResetSuccess'),

    $recoverPasswordLink2: $('#RecoverPassword2'),
    $hideRecoverPasswordLink2: $('#HideRecoverPasswordLink2'),
    $recoverPasswordForm2: $('#RecoverPasswordForm2'),
    $customerLoginForm2: $('#CustomerLoginForm2')
  };
};

timber.init = function () {
  timber.initCache();
  timber.accessibleNav();
  timber.drawersInit();
  timber.responsiveVideos();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var classes = {
    active: 'nav-hover',
    focus: 'nav-focus',
    outside: 'nav-outside',
    hasDropdown: 'site-nav--has-dropdown',
    link: 'site-nav__link'
  };
  var selectors = {
    active: '.' + classes.active,
    hasDropdown: '.' + classes.hasDropdown,
    dropdown: '[data-meganav-dropdown]',
    link: 'a',
    nextLink: '> a',
    parentLink: '[data-meganav-type="parent"]',
    childLink: '[data-meganav-type="child"]'
  };

  var $nav = timber.cache.$navigation,
    $allLinks = $nav.find(selectors.link),
    $parents = $nav.find(selectors.hasDropdown),
    $childLinks = $nav.find(selectors.childLink),
    $topLevel = $parents.find(selectors.nextLink),
    $dropdowns = $nav.find(selectors.dropdown),
    $subMenuLinks = $dropdowns.find(selectors.link);

  // Mouseenter
  $parents.on('mouseenter touchstart', function (evt) {
    var $el = $(this);
    var evtType = evt.type;
    var $dropdowns = $nav.find(selectors.active);

    if (!$el.hasClass(classes.active)) {
      // force stop the click from happening
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }

    // Make sure we close any opened same level dropdown before opening a new one
    if (evtType === 'touchstart' && $dropdowns.length > 0) {
      hideDropdown($el);
    }

    showDropdown($el);
  });

  $childLinks.on('touchstart', function (evt) {
    evt.stopImmediatePropagation();
  });

  $parents.on('mouseleave', function () {
    hideDropdown($(this));
  });

  $allLinks.on('focus', function () {
    handleFocus($(this));
  });

  $allLinks.on('blur', function () {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus($el) {
    var $newFocus = null,
      $previousItem = $el.parent().prev();

    // Always put tabindex -1 on previous element just in case the user is going backward.
    // In that case, we want to focus on the previous parent and not the previous parent childs

    $allLinks.attr('tabindex', '');

    if ($previousItem.hasClass(classes.hasDropdown)) {
      $previousItem.find(selectors.dropdown + ' a').attr('tabindex', -1);
    }

    $newFocus = $el.parents(selectors.hasDropdown).find('> a');
    addFocus($newFocus);
  }

  function showDropdown($el) {
    var $toplevel = $el.find(selectors.nextLink);

    $toplevel.attr('aria-expanded', true);

    $el.addClass(classes.active);

    setTimeout(function () {
      timber.cache.$body.on('touchstart.MegaNav', function () {
        hideDropdowns();
      });
    }, 250);
  }

  function hideDropdown($el) {
    var $dropdowns = $el.parent().find(selectors.active);
    var $parentLink = $dropdowns.find(selectors.nextLink);

    $parentLink.attr('aria-expanded', false);

    $dropdowns.removeClass(classes.active);

    timber.cache.$body.off('touchstart.MegaNav');
  }

  function hideDropdowns() {
    var $dropdowns = $nav.find(selectors.active);
    $.each($dropdowns, function () {
      hideDropdown($(this));
    });
  }

  function addFocus($el) {
    $el.addClass(classes.focus);

    if ($el.attr('aria-expanded') !== undefined) {
      $el.attr('aria-expanded', true);
    }
  }

  function removeFocus($el) {
    $el.removeClass(classes.focus);

    $subMenuLinks.attr('tabindex', -1);

    if ($el.attr('aria-expanded') !== undefined) {
      $el.attr('aria-expanded', false);
    }
  }

  // Check if dropdown is outside of viewport
  function handleDropdownOffset($dropdowns) {
    var viewportSize = $(window).width();
    $dropdowns.removeClass(classes.outside);

    $.each($dropdowns, function () {
      var $dropdown = $(this);
      var dropdownOffset = $dropdown.offset().left + $dropdown.width();
      if (dropdownOffset > viewportSize) {
        $dropdown.addClass(classes.outside);
      }
    });
  }

  timber.cache.$window.load(function () {
    handleDropdownOffset($dropdowns);
  });

  timber.cache.$window.resize(function () {
    afterResize(function () {
      handleDropdownOffset($dropdowns);
    }, 250);
  });
};

timber.drawersInit = function () {

};

timber.getHash = function () {
  return window.location.hash;
};

timber.responsiveVideos = function () {
  var $iframeVideo = $(
    'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
  );
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    if (!$(this).parents('.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's 'incorrect iFrame content on 'back'' bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.loginForms = function () {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function showRecoverPasswordForm2() {
    timber.cache.$recoverPasswordForm2.show();
    timber.cache.$customerLoginForm2.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  function hideRecoverPasswordForm2() {
    timber.cache.$recoverPasswordForm2.hide();
    timber.cache.$customerLoginForm2.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$recoverPasswordLink2.on('click', function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm2();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink2.on('click', function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm2();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() === '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function () {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-button-' + position,
      openButtonLeftClass: 'js-drawer-open-button-left',
      drawerLeftClass: 'drawer--left',
      drawerRightClass: 'drawer--right',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('#PageContainer'),
      $moved: $('.page-container')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $openBtn.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Other drawers that might be open (will be closed later)
    var $otherDrawers = $('.drawer').not(this.$drawer);

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      if (evt) {
        evt.preventDefault();
      }
      return;
    }

    // Close other drawers if they are open
    var self = this;
    $otherDrawers.each(function () {
      if (!$(this).hasClass(self.config.openClass)) {
        return;
      }

      if ($(this).hasClass(self.config.drawerLeftClass)) {
        timber.LeftDrawer.close();
      }

      if ($(this).hasClass(self.config.drawerRightClass)) {
        timber.RightDrawer.close();
      }
    });

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.$drawer.addClass(this.config.openClass);

    this.drawerIsOpen = true;

    // Set focus on drawer
    Drawer.prototype.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when drawer opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function (evt) {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    if (evt.keyCode !== 27) {
      evt.preventDefault();
    }
    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );
    this.$drawer.removeClass(this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    Drawer.prototype.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  /**
   * Traps the focus in a particular container
   *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
      options.$container.attr('tabindex', '-1');
    }

    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  Drawer.prototype.bindEvents = function () {
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function () {
      return false;
    });

    this.$drawer.on('click.drawer', function (event) {
      if ($(this).hasClass('drawer--left')) {
        event.stopPropagation();
      }
    });

    $('.page-container, .drawer__header-container').on(
      'click.drawer',
      this.close.bind(this)
    );

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function (evt) {
        // The hamburger 'open' button changes to a 'close' button when the drawer
        // is open. Clicking on it will close the drawer.
        if (this.$activeSource !== undefined) {
          this.$activeSource.on(
            'click.drawer',
            $.proxy(function () {
              if (
                !this.$activeSource.hasClass(this.config.openButtonLeftClass)
              ) {
                return;
              }
              this.close();
            }, this)
          );
        }
        if (evt.keyCode === 27) {
          this.close(evt);
        }
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    if (this.$activeSource !== undefined) {
      this.$activeSource.off('.drawer');
    }
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

/*
 * Shopify JS for customizing Slick.js
 *   http://kenwheeler.github.io/slick/
 *   Untouched JS in assets/slick.min.js
 */

var slickTheme = (function (module, $) {
  'use strict';

  // Public functions
  var init, onInit, beforeChange, afterChange;

  // Private variables
  var settings,
    $slider,
    $allSlides,
    $activeSlide,
    $pagination,
    scrolled,
    $heroText,
    $heroImage;
  var currentActiveSlide = 0;

  // Private functions
  var cacheObjects,
    setParallax,
    calculateParallax,
    keyboardNavigation,
    togglePause,
    showMobileText,
    applySlideColor,
    slideshowA11ySetup;

  /*============================================================================
   Initialise the plugin and define global options
  ==============================================================================*/
  cacheObjects = function () {
    slickTheme.cache = {
      $html: $('html'),
      $window: $(window),
      $hero: $('#Hero'),
      $heroImage: $('.hero__image'),
      $headerWrapper: $('.header-wrapper'),
      $pauseButton: $('.hero__pause'),
      $textWrapperMobile: $('.hero__adapt-text-wrap')
    };

    slickTheme.vars = {
      slides: '.slick-slide',
      activeSlide: '.slick-active',
      slideImage: '.hero__image',
      slickList: '.slick-list',
      textContent: '.hero__text-content',
      pagination: '[data-slide-pagination]',
      hiddenClass: 'hero__slide--hidden',
      heroHeaderClass: 'hero__header',
      pausedClass: 'is-paused',
      loadSlideA11yString: slickTheme.cache.$hero.data('slide-nav-a11y'),
      activeSlideA11yString: slickTheme.cache.$hero.data(
        'slide-nav-active-a11y'
      )
    };
  };

  init = function (options) {
    cacheObjects();

    // Default settings
    settings = {
      // User options
      $element: null,
      parallax: false,

      // Private settings
      isTouch: Modernizr.touch ? true : false,

      // Slick options
      accessibility: true,
      arrows: false,
      dots: true,
      focusOnChange: true,
      adaptiveHeight: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    /*
     * Init slick slider
     *   - Add any additional option changes here
     *   - https://github.com/kenwheeler/slick/#options
     */
    settings.$element.slick({
      accessibility: settings.accessibility,
      arrows: settings.arrows,
      dots: settings.dots,
      slide: '.hero__slide',
      /* eslint-disable shopify/jquery-dollar-sign-reference */
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      appendDots: $('.hero__dots-wrapper'),
      /* eslint-enable shopify/jquery-dollar-sign-reference */
      adaptiveHeight: false,
      draggable: false,
      fade: true,
      focusOnChange: settings.focusOnChange,
      autoplay: slickTheme.cache.$hero.data('autoplay'),
      autoplaySpeed: slickTheme.cache.$hero.data('autoplayspeed'),
      onInit: this.onInit,
      onBeforeChange: this.beforeChange,
      onAfterChange: this.afterChange,
      customPaging: function (slick, index) {
        var labelString =
          index === 0
            ? slickTheme.vars.activeSlideA11yString
            : slickTheme.vars.loadSlideA11yString;
        return (
          '<a href="#Hero" aria-label="' +
          labelString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '" data-slide-pagination aria-controls="SlickSlide' +
          (index + 1) +
          '"></a>'
        );
      }
    });
  };

  onInit = function (obj) {
    $slider = obj.$slider;
    $allSlides = $slider.find(slickTheme.vars.slides);
    $activeSlide = $slider.find(
      slickTheme.vars.slides + slickTheme.vars.activeSlide
    );
    $pagination = $slider.find(slickTheme.vars.pagination);

    if (!settings.isTouch) {
      $allSlides.addClass(slickTheme.vars.hiddenClass);
      $activeSlide.removeClass(slickTheme.vars.hiddenClass);
    }

    if (settings.autoplay) {
      slickTheme.cache.$pauseButton.on('click', togglePause);

      $(document).scroll(
        theme.debounce(
          function () {
            if (this.$slider.outerHeight() < window.pageYOffset) {
              settings.$element.slickPause();
            } else if (
              !slickTheme.cache.$pauseButton.hasClass(
                slickTheme.vars.pausedClass
              )
            ) {
              settings.$element.slickPlay();
            }
          }.bind(this),
          250
        )
      );
    }

    // Prevent default slick behaviour of autoplaying on mouseleave
    slickTheme.cache.$hero
      .find(slickTheme.vars.slickList)
      .off('mouseleave.slick');

    if (settings.adaptHeight) {
      showMobileText(0);
    }

    slideshowA11ySetup();

    if (settings.parallax && Modernizr.csstransforms3d) {
      setParallax();
    }
  };

  beforeChange = function (evt, currentSlide, nextSlide) {
    if (!settings.isTouch) {
      $allSlides.removeClass(slickTheme.vars.hiddenClass);
    }

    if (settings.adaptHeight) {
      showMobileText(nextSlide);
    }

    applySlideColor(nextSlide, currentSlide);

    $pagination.each(function (index) {
      var labelString =
        index === nextSlide
          ? slickTheme.vars.activeSlideA11yString
          : slickTheme.vars.loadSlideA11yString;

      labelString = labelString.replace('[slide_number]', index + 1);
      $(this).attr('aria-label', labelString);
    });

    // Set upcoming slide as index
    currentActiveSlide = nextSlide;

    // Set new active slide to proper parallax position
    if (settings.parallax && Modernizr.csstransforms3d) {
      calculateParallax(currentActiveSlide);
    }
  };

  afterChange = function () {
    if (settings.isTouch) {
      return;
    }

    $activeSlide = $slider.find(
      slickTheme.vars.slides + slickTheme.vars.activeSlide
    );
    $allSlides.addClass(slickTheme.vars.hiddenClass).attr('aria-hidden', true);
    $activeSlide
      .removeClass(slickTheme.vars.hiddenClass)
      .attr('aria-hidden', false);
  };

  setParallax = function () {
    $heroText = $(slickTheme.vars.textContent);
    $heroImage = $(slickTheme.vars.slideImage);

    slickTheme.cache.$window.on('scroll', function () {
      calculateParallax(currentActiveSlide);
    });
  };

  calculateParallax = function (currentSlide) {
    scrolled = slickTheme.cache.$window.scrollTop();

    $($heroText[currentSlide]).css({
      transform: 'translate3d(0, ' + scrolled / 8 + 'px, 0)'
    });

    $($heroImage[currentSlide]).css({
      transform: 'translate3d(0, ' + scrolled / 8 + 'px, 0)'
    });
  };

  keyboardNavigation = function (evt) {
    if (evt.keyCode === 37) {
      settings.$element.slickPrev();
    }
    if (evt.keyCode === 39) {
      settings.$element.slickNext();
    }
  };

  togglePause = function () {
    var $pauseButton = $(this);
    var isPaused = $pauseButton.hasClass(slickTheme.vars.pausedClass);

    $pauseButton
      .toggleClass(slickTheme.vars.pausedClass, !isPaused)
      .attr(
        'aria-label',
        isPaused
          ? $pauseButton.data('label-pause')
          : $pauseButton.data('label-play')
      );

    if (settings.autoplay) {
      if (isPaused) {
        settings.$element.slickPlay();
      } else {
        settings.$element.slickPause();
      }
    }
  };

  showMobileText = function (slideIndex) {
    var $allTextContent = slickTheme.cache.$textWrapperMobile.find(
      slickTheme.vars.textContent
    );
    var $currentTextContent = slickTheme.cache.$textWrapperMobile.find(
      '[data-index="' + slideIndex + '"]'
    );
    if (!$currentTextContent.length && $allSlides.length === 1) {
      slickTheme.cache.$textWrapperMobile.hide();
    } else {
      slickTheme.cache.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  applySlideColor = function (nextSlideIndex, previousSlideIndex) {
    var prefixClassName = 'hero--color-';

    theme.cache.$siteHeader
      .removeClass(prefixClassName + previousSlideIndex)
      .addClass(prefixClassName + nextSlideIndex);
    $slider
      .removeClass(prefixClassName + previousSlideIndex)
      .addClass(prefixClassName + nextSlideIndex);
  };

  slideshowA11ySetup = function () {
    var $list = slickTheme.cache.$hero.find(slickTheme.vars.slickList);

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    slickTheme.cache.$hero
      .on('focusin mouseenter', function (evt) {
        if (
          !slickTheme.cache.$hero.has(evt.target).length ||
          $list.attr('aria-live') === 'polite'
        ) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (settings.autoplay) {
          settings.$element.slickPause();
        }
      })
      .on('focusout mouseleave', function (evt) {
        if (slickTheme.cache.$hero.has(evt.relatedTarget).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (settings.autoplay) {
          // Only resume playing if the user hasn't paused using the pause
          // button
          if (
            !slickTheme.cache.$pauseButton.hasClass(slickTheme.vars.pausedClass)
          ) {
            settings.$element.slickPlay();
          }
        }
      })
      .on('keyup', keyboardNavigation.bind(this));

    $list.removeAttr('tabindex');

    $allSlides.each(function (index) {
      $(this)
        .attr('id', 'SlickSlide' + (index + 1))
        .attr('aria-hidden', true);
    });

    $activeSlide.attr('aria-hidden', false);

    if ($allSlides.length > 1) {
      $pagination.each(function () {
        $(this).on('click keyup', function (evt) {
          if (evt.type === 'keyup' && evt.which !== 13) return;

          evt.preventDefault();

          if (evt.type === 'keyup') {
            slickTheme.cache.$hero.focus();
          }
        });
      });
    }
  };

  module = {
    init: init,
    onInit: onInit,
    beforeChange: beforeChange,
    afterChange: afterChange
  };

  return module;
})(slickTheme || {}, jQuery);


/* ================ Sections ================ */
theme.Product = (function () {
  function Product(container) {
    this.$container = $(container);
    this.$blocks = $('[data-blocks]', this.$container);

    this.productGallery = new slate.ProductGallery(this.$container);

    this.productForm = new slate.ProductForm(this.$container, {
      onColorSelectChange: this.onColorSelectChange.bind(this),
      onRaffleModeSubmit: this.onRaffleModeSubmit.bind(this)
    });
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    onColorSelectChange: function (color) {
      this.productGallery.onColorSelectChange(color)
    },

    onRaffleModeSubmit: function () {
      if (this.$blocks.length === 0) {
        return
      }

      this.$blocks.get(0).scrollIntoView({ behavior: 'smooth' });
    },

    onUnload: function () {
      this.productForm.onUnload();
      this.productGallery.destroyImageCarousel();
    }
  });

  return Product;
})();

theme.Collection = (function () {
  function Collection(container) {
    this.selectors = {
      productGridImages: '.grid-uniform .grid-product__image-wrapper',
      $productGridRows: $('.collage-grid__row'),
      productGridPhotosLarge: '.grid__item--large .grid-product__image-link',
      $collectionImage: $('.collection-hero__image'),
      filterDropdowns: '.filter-dropdown',
      filterSelect: '.filter-dropdown__select',
      filterLabel: '.filter-dropdown__label',
      sortDropdown: '#sortBy'
    };

    var $container = (this.$container = $(container));
    this.gridType = $container.data('grid-type');

    this.selectors.$collectionImage.addClass('is-init');

    // Enable parallax effect if 3d transforms are supported
    if (!Modernizr.csstransforms3d) {
      return;
    }

    theme.cache.$window.on('scroll', function () {
      var scrolled = theme.cache.$window.scrollTop();
      theme.cache.$collectionImage.css({
        transform: 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)'
      });
    });

    this.init();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    init: function () {
      this.cacheSelectors();
      this.setQueryParams();

      this.cache.$sortDropdown.on('change', this.sortCollection.bind(this));

      if (this.gridType === 'collage') {
        this.initCollageGrid();
      } else if (this.gridType === 'grid') {
        theme.equalHeights.call(this);
      }
    },

    updateFilterLabel: function (evt, element) {
      var $select = evt ? $(evt.target) : $(element);
      var $label = $select
        .prev('.filter-dropdown__label')
        .find('.filter-dropdown__label--active');
      var selectedVariant = $select.find('option:selected').text();

      $label.html(' ' + selectedVariant);
      this.cache.$filterDropdowns.addClass('loaded');
    },

    cacheSelectors: function () {
      this.cache = {
        $html: $('html'),
        $window: $(window),
        $productGridImages: $(this.selectors.productGridImages),
        $productGridRows: $(this.selectors.productGridRows),
        $productGridPhotosLarge: $(this.selectors.productGridPhotosLarge),
        $filterDropdowns: $(this.selectors.filterDropdowns),
        $filterSelect: $(this.selectors.filterSelect),
        $filterLabel: $(this.selectors.filterLabel),
        $sortDropdown: $(this.selectors.sortDropdown)
      };
    },

    setQueryParams: function () {
      //don't execute if sort dropdown is not present.
      if (!this.cache.$sortDropdown.length) {
        return;
      }

      Shopify.queryParams = this.parseQueryString();
    },

    parseQueryString: function () {
      if (!location.search.length) {
        return {};
      }

      var params = {};

      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          params[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(
            aKeyValue[1]
          );
        }
      }
      return params;
    },

    initCollageGrid: function () {
      if (!this.cache.$productGridRows.length) {
        return;
      }

      this.collageGridHeights();

      theme.cache.$window.on(
        'resize',
        theme.debounce(this.collageGridHeights, 500)
      );
    },

    collageGridHeights: function () {
      if (theme.variables.bpSmall || !this.cache.$productGridRows.length) {
        return;
      }

      // calculate image heights for each row of grid images
      for (var i = this.cache.$productGridRows.length - 1; i >= 0; i--) {
        var $currentRow = $(this.cache.$productGridRows[i]);
        var $smallImages = $currentRow.find(
          '.grid__item--small .grid-product__image-wrapper'
        );
        var $largeImageWrapper = $currentRow.find(
          '.grid__item--large .grid-product__image-wrapper'
        );
        var $largeImage = $largeImageWrapper.find('.grid-product__image-link');

        // calculate the bottom edge of the small image
        var smallImageOffset =
          $smallImages[1].offsetTop + $smallImages[1].offsetHeight;

        // calculate the bottom edge of the large image for the row
        var largeImageOffset =
          $largeImageWrapper[0].offsetTop + $largeImageWrapper[0].offsetHeight;

        var largeImageHeight = 0;

        // Depending on which image is lower, increase or decrease the large
        // image size
        if (smallImageOffset > largeImageOffset) {
          largeImageHeight =
            $largeImage.height() + (smallImageOffset - largeImageOffset);
        } else {
          largeImageHeight =
            $largeImage.height() - (largeImageOffset - smallImageOffset);
        }

        $largeImage.css('height', largeImageHeight);
      }
    },

    clearCollageGridHeights: function () {
      if (!this.cache.$productGridRows.length) {
        return;
      }

      this.cache.$productGridPhotosLarge.removeAttr('style');
    },

    collectionSorting: function () {
      if (!this.cache.$tagList.length) {
        return;
      }

      this.cache.$tagList.on('change', function () {
        window.location.href = $(this).val();
      });
    },

    sortCollection: function () {
      if (!this.cache.$sortDropdown.length) {
        return;
      }

      if (Shopify.queryParams.page) {
        delete Shopify.queryParams.page;
      }
      Shopify.queryParams.sort_by = this.cache.$sortDropdown.val();
      location.search = jQuery.param(Shopify.queryParams);
    }
  });

  return Collection;
})();

theme.HeaderSection = (function () {
  function Header(container) {
    timber.drawersInit();
    theme.initCache();
    theme.fitNav();
    theme.resizeLogo();

    this.$container = $(container);

    theme.cache.$window.on('load', theme.resizeLogo);
    theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));

    // Check for header absolute position
    if ($('#Hero').hasClass('hero')) {
      $('.header-wrapper').addClass('hero__header');
    } else {
      $('.header-wrapper').removeClass('hero__header');
    }

    // Mobile nav dropdown
    var $navDropdown = $('#NavDropdown');
    var $mobileDropdown = $('#mobile-dropdown');
    var $controls = $('[aria-controls="mobile-dropdown"]');

    $navDropdown.on('click', function () {
      var isOpen = $mobileDropdown.hasClass('open');

      $mobileDropdown.toggleClass('open', !isOpen);
      $('body').toggleClass('js-drawer-open-down', !isOpen);
      $controls.attr('aria-expanded', !isOpen);
    });    

    this.initSideBarDropDowns();
    this.watchGlobalEInjection();

    window.addEventListener(CartAPI.EVENTS.UPDATE, this.onCartUpdate.bind(this));
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onCartUpdate: function(e) {
      const { detail: { cart } } = e;

      var $link = this.$container.find('.cart-link');
      var $itemCount = this.$container.find('.cart-item-count');
      
      $link.toggleClass('has-items', cart.item_count > 0);
      $itemCount.text(cart.item_count);
    },

    onSelect: function (event) {
      this.handleDrawerOpenInEditor(event);
    },

    onDeselect: function (event) {
      timber.LeftDrawer.close(event);
    },

    handleDrawerOpenInEditor: function (event) {
      if (
        theme.cache.$siteNav.hasClass('site-nav--compress') ||
        theme.variables.bpSmall
      ) {
        setTimeout(function () {
          timber.LeftDrawer.drawerIsOpen = false;
          timber.LeftDrawer.open();
        }, 500);
      } else if (!theme.cache.$siteNav.hasClass('site-nav--compress')) {
        timber.LeftDrawer.drawerIsOpen = true;
        timber.LeftDrawer.close(event);
      }
    },

    initSideBarDropDowns: function () {
      var $toggleBtns = $('.mobile-nav__toggle-btn');
      // Setup aria attributes
      $toggleBtns.attr('aria-expanded', 'false');

      $toggleBtns.each(function () {
        var $button = $(this);
        $button.attr('aria-controls', $button.attr('data-aria-controls'));
      });

      $toggleBtns.on('click', function () {
        var $button = $(this);
        var currentlyExpanded = $button.attr('aria-expanded');
        var toggleState = false;
        // Updated aria-expanded value based on state pre-click
        if (currentlyExpanded === 'true') {
          $button.attr('aria-expanded', 'false');
        } else {
          $button.attr('aria-expanded', 'true');
          toggleState = true;
        }

        // Toggle that expands/collapses sublist
        $button
          .closest('.mobile-nav__has-sublist')
          .toggleClass('mobile-nav--expanded', toggleState)
          .next()
          .slideToggle();
      });
    },

    // Watch Global-e "flag" injection so we can add alt text
    // @TODO - Can we get rid of this observer?
    watchGlobalEInjection: function () {
      if (!window.MutationObserver) return

      var $mobileDropdown = $('#mobile-dropdown');
      var $utilityNav = $('#utility_nav');

      var observer;
      var config = {
        childList: true,
        subtree: true
      }

      observer = new MutationObserver(function (mutationsList, observer) {
        for (var i = mutationsList.length - 1; i >= 0; i--) {
          var mutation = mutationsList[i]

          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            var $node = $(mutation.addedNodes[0])

            if ($node.hasClass('ge_shipping_switcher')) {
              $node.find('img').attr('alt', 'Change Location')
            }
          }
        }

        if (mutationsList.length === 2) {
          observer.disconnect();
        }
      }.bind(this))

      observer.observe($mobileDropdown.get(0), config);
      observer.observe($utilityNav.get(0), config);
    }
  });

  return Header;
})();

theme.FooterSection = (function() {
  function Footer(container) {
    this.$container = $(container);

    this.subscribeForm = new slate.SubscribeForm(this.$container);
  }

  return Footer;
})();

theme.Backdrop = (function() {
  const classes = {
    backdrop: 'backdrop',
    open: 'is-open'
  };

  function Backdrop(el) {
    this.el = el;
  }

  Backdrop.prototype = _.assignIn({}, Backdrop.prototype, {
    show: function() {
      this.el.classList.add(classes.open)
      this.el.setAttribute('aria-hidden', 'false')
    },
    close: function() {
      this.el.classList.remove(classes.open)
      this.el.setAttribute('aria-hidden', 'true')
    }
  })

  function Generate(parent, options = {}) {
    const el = document.createElement('button')

    const settings = {
      title: 'Close',
      ariaLabel: 'Close',
      ariaControls: null,
      ariaExpanded: false,
      ...options
    }

    el.classList.add(classes.backdrop)
    el.setAttribute('type', 'button')
    el.setAttribute('title', settings.title)
    el.setAttribute('aria-label', settings.ariaLabel || settings.title)
    el.setAttribute('aria-expanded', settings.ariaExpanded ? 'true' : 'false')
    el.setAttribute('aria-hidden', settings.ariaExpanded ? 'false' : 'true')
    
    if (settings.ariaControls) {
      el.setAttribute('aria-controls', settings.ariaControls)
    }

    const appendTo = parent || document.body
    appendTo.appendChild(el)

    return new Backdrop(el)    
  }

  return {
    Generate
  };
})();

theme.CartUpsellItem = (function() {
  function CartUpsellItem(el, settings = {}) {
    this.$el = $(el);
    this.$form = this.$el.find('form');
    this.$submit = this.$el.find('button[type="submit"]');

    this.variantId = this.$el.data('variant-id');
    this.category = this.$el.data('category');

    this.submitInProgress = false;

    this.settings = {
      onAddSuccess: $.noop,
      ...settings
    }

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.$form.on('submit', this.onFormSubmit);
  }

  CartUpsellItem.prototype = _.assignIn({}, CartUpsellItem.prototype, {
    destroy: function() {
      this.$el.remove();
      this.$form.off('submit', this.onFormSubmit);
    },
    onFormSubmit: function(e) {
      e.preventDefault();

      if (this.submitInProgress) {
        return false;
      }
      
      this.$submit.prop('disabled', true);
      this.$submit.html('Adding...');
      this.$submit.addClass('btn--loading');

      this.submitInProgress = true;

      CartAPI.addItemFromForm(this.$form.get(0))
        .then(cart => {
          this.$submit.text('Added!');
          this.$submit.removeClass('btn--loading');
          this.settings.onAddSuccess(this);
        })
        .catch(error => {
          console.error('onAdd Error', error);
          this.$submit.text('Add to Cart');
          this.$submit.removeClass('btn--loading');
        })
        .finally(() => {
          this.$submit.prop('disabled', false);
          this.submitInProgress = false;
        });
    }
  })
  
  return CartUpsellItem;
})();

theme.CartUpsells = (function() {
  function CartUpsells(container) {
    this.$container = $(container);
    this.$slots = this.$container.find('[data-slot]');

    this.randomize = this.$container.data('randomize') === true;
    this.upsellItemInstances = [];
    this.cachedUpsellsData = null;

    // Fetch the upsells on init
    CartAPI.getCartUpsells()
      .then(data => {    
        data = this.sortData(data);

        this.cachedUpsellsData = data;

        if (!data || !data.items || data.items.length === 0) {
          this.toggleContainer(false);
          return;
        }

        this.populateSlots(data.items, false);
        this.toggleContainer(true);
      })
      .catch(error => {
        console.error('getCartUpsells Error', error);
      })
      .finally(() => {
        window.addEventListener(CartAPI.EVENTS.ADD, this.onCartAdd.bind(this));
      });
  }

  CartUpsells.prototype = _.assignIn({}, CartUpsells.prototype, {
    sortData: function(data) {
      if (!data || !data.items) {
        return data;
      }

      if (this.randomize) {
        // if (prioritizeFootwear) {
          // const footwearItems = data.items.filter(item => item.category === 'footwear');
          // const generalItems = data.items.filter(item => item.category === 'general');
  
          // footwearItems.sort(() => Math.random() - 0.5);
          // generalItems.sort(() => Math.random() - 0.5);
  
          // data.items = [...footwearItems, ...generalItems];          
        // }
        // else {
          data.items.sort(() => Math.random() - 0.5);
        // }
      }

      return data;
    },
    toggleContainer: function(show) {
      this.$container.toggle(show);
    },
    populateSlots: function(items = [], animate = true) {
      items.slice(0, 2).forEach((item, index) => {
        const nextInstance = this.displayUpsellItem(item.item_html, this.$slots.eq(index));

        if (animate) {
          nextInstance.$el.hide();
          nextInstance.$el.fadeIn(500);        
        }
      });
    },
    displayUpsellItem: function(itemHtml, $slot) {
      if (!itemHtml || !$slot) {
        console.warn('displayUpsellItem: No itemHtml or slot provided');
        return;
      }

      const $itemHtml = $(itemHtml);

      $slot.empty();
      $slot.append($itemHtml)

      const itemInstance = this.createUpsellItemInstance($itemHtml)
      this.upsellItemInstances.push(itemInstance)

      return itemInstance;
    },
    createUpsellItemInstance: function(itemHtml) {
      return new theme.CartUpsellItem(itemHtml, {
        onAddSuccess: this.onUpsellItemAddSuccess.bind(this)
      });
    },
    getNextUpsell: function() {
      if (!this.cachedUpsellsData || !this.cachedUpsellsData.items) {
        return null;
      }
            
      const instanceVariantIds = this.upsellItemInstances.map(i => i.variantId);

      return this.cachedUpsellsData.items.find(i => !instanceVariantIds.includes(i.variant_id))
    },
    refreshUpsellItem: function(itemInstance) {
      const nextUpsell = this.getNextUpsell()
      const $slot = itemInstance.$el.parent();

      // Fade the container out if there are no more upsells and we're on the last one
      if (!nextUpsell && this.upsellItemInstances.length === 1) {
        this.$container.fadeOut(300)
      }
    
      itemInstance.$el.fadeOut(300, () => {
        itemInstance.destroy()
        this.upsellItemInstances = this.upsellItemInstances.filter(i => i.variantId !== itemInstance.variantId);

        if (!this.cachedUpsellsData || this.cachedUpsellsData.items.length === 0) {
          this.toggleContainer(false);
          return
        }

        this.toggleContainer(true);

        if (!nextUpsell) {
          $slot.remove();
          return
        }

        const nextInstance = this.displayUpsellItem(nextUpsell.item_html, $slot)

        if (nextInstance) {
          nextInstance.$el.hide();
          nextInstance.$el.fadeIn(500);
        }
      });
    },
    onUpsellItemAddSuccess: function(itemInstance) {
      // Remove the variant id from the cached upsells data
      this.cachedUpsellsData.items = this.cachedUpsellsData.items.filter(item => item.variant_id !== itemInstance.variantId);

      this.refreshUpsellItem(itemInstance)
    },
    onCartAdd: function(e) {
      if (!e.detail.cart || !e.detail.cart.added_item) return;

      const addedItemVariantId = e.detail.cart.added_item.variant_id;
      const upsellsData = e.detail.cart.upsells;

      if (!upsellsData || !upsellsData.items) {
        console.warn('onCartAdd: No upsells data in cart response');
        return;
      }
      
      upsellsData.items = upsellsData.items.filter(item => item.variant_id !== addedItemVariantId);
      upsellsData = this.sortData(upsellsData)

      // If they added an item from the upsells, then assume the cart total hasn't changed much, just swap out that upsell
      if (this.cachedUpsellsData && this.cachedUpsellsData.items.some(item => item.variant_id === addedItemVariantId)) {
        this.cachedUpsellsData = upsellsData;

        const itemInstance = this.upsellItemInstances.find(item => item.variantId === addedItemVariantId);

        if (itemInstance) {
          this.refreshUpsellItem(itemInstance);
        }
      }
      else {
        this.cachedUpsellsData = upsellsData;

        this.upsellItemInstances.forEach(item => item.destroy());
        this.upsellItemInstances = [];

        this.populateSlots(upsellsData.items, false);
        // We can only add products while the cart is hidden so it's okay to toggle the container immediately
        this.toggleContainer(upsellsData.items.length > 0);        
      }
    }
  });

  return CartUpsells;
})();

theme.CartDrawer = (function() {
  const classes = {
    isEmpty: 'is-empty',
    bodyIsOpen: 'cart-drawer-open',
    itemIsBusy: 'is-busy',
    itemIsRemoving: 'is-removing'
  };

  function CartDrawer(container) {
    this.$container = $(container);
    this.$drawer = this.$container.find('[data-cart-drawer]');
    this.$cartBody = this.$container.find('[data-cart-body]');
    this.$form = this.$container.find('form[action="/cart"]');
    this.$submitButton = this.$container.find('button[name="checkout"]');
    this.$subtotalPrice = this.$container.find('[data-subtotal-price]');
    this.$itemsLabelText = this.$container.find('[data-cart-items-label-text]');
    this.$closeButton = this.$container.find('[data-cart-drawer-close]');
    this.$clearButton = this.$container.find('[data-cart-drawer-clear]');
    this.$scroller = this.$container.find('[data-scroller]');

    this.isOpen = false;

    this.backdrop = theme.Backdrop.Generate(document.body, {
      ariaControls: this.$drawer.attr('id'),
      ariaExpanded: false
    })

    $(document.body).on('click', e => {
      if (this.ariaControlElements().is(e.target) || this.ariaControlElements().has(e.target).length) {
        e.preventDefault()
        this.toggle()
      }  
    })

    this.$container.on('click', '[data-item-remove]', e => {
      e.preventDefault();
      this.removeItem($(e.target).closest('[data-cart-item]'));
    });

    this.$closeButton.on('click', e => {
      e.preventDefault();
      this.close();
    });

    this.$clearButton.on('click', e => {
      e.preventDefault();
      this.clearCart();
    });

    this.$submitButton.removeClass('btn--loading'); // This happens if you click "back" from checkout?
    this.$form.on('submit', e => {
      this.$submitButton.addClass('btn--loading');
    });

    window.addEventListener(CartAPI.EVENTS.UPDATE, this.onCartUpdate.bind(this));

    this.upsells = null;

    if (this.$container.find('[data-cart-upsells]').length) {
      this.upsells = new theme.CartUpsells(this.$container.find('[data-cart-upsells]'));
    }
  }

  CartDrawer.prototype = _.assignIn({}, CartDrawer.prototype, {
    ariaControlElements: function() {
      return $('[aria-controls="' + this.$drawer.attr('id') + '"]')
    },
    onSelect: function() {
      this.open()
    },
    onDeselect: function() {
      this.close()
    },    
    open: function() {
      if (this.isOpen) return

      this.$drawer.addClass('is-open')
      this.$drawer.attr('aria-hidden', 'false')
      this.$drawer.get(0).removeAttribute('inert')

      this.ariaControlElements().attr('aria-expanded', 'true')

      document.body.classList.add(classes.bodyIsOpen);

      this.backdrop.show()

      // NOTE: It's a little weird to be using this prototype method from another module
      // but it does what we need it to and doesn't cost us another library so let's run it
      timber.Drawers.prototype.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      this.isOpen = true;
    },
    close: function() {
      if (!this.isOpen) return

      this.$drawer.removeClass('is-open')
      this.$drawer.attr('aria-hidden', 'true')
      this.$drawer.attr('inert', 'true')

      this.ariaControlElements().attr('aria-expanded', 'false')

      document.body.classList.remove(classes.bodyIsOpen);

      setTimeout(() => {
        this.$scroller.get(0).scrollTo({
          top: 0,
          behavior: 'instant'
        })
      }, 400) // Wait for close animation to complete - don't put this on the open method

      this.backdrop.close()

      timber.Drawers.prototype.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      this.isOpen = false;
    },
    toggle: function() {
      return this.isOpen ? this.close() : this.open()
    },
    clearCart: function() {
      return CartAPI.clearCart();
    },
    removeItem: function($item) {
      const id = $item.data('id');

      if (!id) return;

      $item.addClass(classes.itemIsBusy)

      return CartAPI.changeLineItemQuantity(id, 0);
    },
    onCartUpdate: function(e) {
      const { detail: { cart } } = e;
      
      const cartIsOpen = this.isOpen;
      const addedItemEls = []
      const isEmpty = cart.item_count === 0;
      const currentCartItems = Array.from(this.$cartBody.get(0).querySelectorAll('[data-cart-item]'))
      const currentCartItemIds = currentCartItems.map(el => parseInt(el.dataset.id))

      const updatedCartItemIds = cart.items.map(item => item.id);
      const itemsRemovedIds = currentCartItemIds.filter(id => !updatedCartItemIds.includes(id)) || [];            

      // First, update items for three scenarios: added, removed, or updated (default)
      cart.items.forEach((newItemData, newIndex) => {
        let found = false;
        const $newItemHtml = $(newItemData.item_html);

        currentCartItemIds.forEach((currentItemId, currentIndex) => {
          if (currentItemId === newItemData.id) {
            found = true;

            // Swap the contents out
            // If we swap the entire thing then the image has to rerender and we get a flash
            const currentContents = currentCartItems[currentIndex].querySelector('[data-contents]')
            const newContents = $newItemHtml.find('[data-contents]').get(0)

            if (currentContents && newContents) {
              currentContents.replaceWith(newContents)
            }
          }
        })

        if (!found) {
          // It's a new item, need to add it
          this.$cartBody.get(0).insertBefore($newItemHtml.get(0), currentCartItems[newIndex] || null)

          if (cartIsOpen) {
            $newItemHtml
              .hide()
              .slideDown({
                duration: 300,
                easing: 'easeInOutCubic'
              });
            $newItemHtml.children().first()
              .css('opacity', 0)
              .delay(100)
              .animate({
                opacity: 1
              }, {
                duration: 400,
                easing: 'easeInOutCubic'
              })
          }      

          addedItemEls.push($newItemHtml.get(0))
        }
      })

      itemsRemovedIds.forEach(id => {
        const $item = $(currentCartItems.find(el => parseInt(el.dataset.id) === id));

        $item
          .addClass(classes.itemIsRemoving)
          .animate({
            height: 0,
          }, {
            duration: 300,
            easing: 'easeInOutCubic',
            complete: () => {
              $item.remove()
            }
          })
      });

      if (addedItemEls.length > 0) {
        const addedEl = addedItemEls[0];
        const index = [].indexOf.call(addedEl.parentNode.children, addedEl);
        const behavior = cartIsOpen ? 'smooth' : 'instant';

        if (index === 0) {
          this.$scroller.get(0).scrollTo({ top: 0, behavior })
        }
        else {
          addedEl.scrollIntoView({ behavior })
        }
      }

      // Now handle everything else
      this.$subtotalPrice.html(cart.items_subtotal_price_formatted);

      const itemLabelText = `${cart.item_count} Item${cart.item_count === 1 ? '' : 's'}`;

      if (!isEmpty) {
        this.$itemsLabelText.text(itemLabelText);
      }
      
      if (window.Shopify && window.Shopify.StorefrontExpressButtons) {
        window.Shopify.StorefrontExpressButtons.initialize();
      }

      this.$form
        .css('pointer-events', isEmpty ? 'none' : 'auto')
        .attr('aria-hidden', isEmpty ? 'true' : 'false')

      this.$submitButton
        .find('button[name="checkout"]').prop('disabled', isEmpty ? true : false);

      this.$drawer.toggleClass(classes.isEmpty, isEmpty);

      this.open();
    }
  });

  return CartDrawer;
})();

theme.SubscribePopupSection = (function() {
  function SubscribePopup(container) {
    this.$container = $(container);

    this.modalId = this.$container.data('modal-id');
    this.showAutomatically = this.$container.data('show-automatically');

    this.modalElement = document.getElementById(this.modalId);

    this.subscribeForm = new slate.SubscribeForm(this.$container, {
      onSuccessAnimationComplete: this.closeModal.bind(this)
    });

    this.throttledOnScroll = theme.throttle(this.onScroll.bind(this), 250)

    // On load, if the popup is set to display automatically, they aren't subscribed and they haven't seen the modal before -
    // add a scroll handler to open it after interacting with the page
    if (this.showAutomatically &&
        !Cookies.get(theme.USER_COOKIES.SUBSCRIBE_POPUP_SEEN) &&
        !Cookies.get(theme.USER_COOKIES.SUBSCRIBE_COMPLETE) &&
        (window.location.pathname === '/' || window.location.pathname.startsWith('/collections'))
    ) {
      theme.cache.$window.on('scroll', this.throttledOnScroll)
    }

    window.addEventListener('hystmodal:beforeOpen', this.onHystModalBeforeOpen.bind(this));
    window.addEventListener('hystmodal:afterClose', this.onHystModalAfterClose.bind(this));
  }

  SubscribePopup.prototype = _.assignIn({}, SubscribePopup.prototype, {
    onSelect: function() {
      this.openModal()
    },

    onDeselect: function() {
      this.closeModal()
    },

    onScroll: function() {      
      if (window.Shopify.designMode || theme.modals.getOpenModal()) return

      if (window.scrollY > (window.innerHeight * 0.75)) {
        this.openModal()
      }
    },

    openModal: function() {
      theme.modals.open('#' + this.modalId);

      if (window.Shopify.designMode) return // No side effects inside the theme editor

      // Set a cookie so that we know they've seen the modal
      Cookies.set(theme.USER_COOKIES.SUBSCRIBE_POPUP_SEEN, true, { expires: 7 })
      theme.cache.$window.off('scroll', this.throttledOnScroll) // Remove scroll handler since we only use it for triggering the modal automatically      
    },

    closeModal: function() {
      if (theme.modals.getOpenModal() === this.modalElement) {
        theme.modals.close();
      }
    },

    onHystModalBeforeOpen: function(event) {
      if (event.detail.element !== this.modalElement) return

      setTimeout(() => {
        this.subscribeForm.$emailInput.trigger('focus')
      }, 500)
    },

    onHystModalAfterClose: function(event) {
      // if (event.detail.element !== this.modalElement) return
    }
  })

  return SubscribePopup;
})();

theme.FeaturedContentSection = (function () {
  function FeaturedContent() {
    theme.styleTextLinks();
  }

  return FeaturedContent;
})();

theme.NewsletterSection = (function () {
  function Newsletter() {
    theme.styleTextLinks();
  }

  return Newsletter;
})();

theme.SlideshowSection = (function () {
  function SlideshowSection() {
    theme.initCache();

    var $slideshow = (this.$slideshow = $('#Hero'));
    var autoplay = (this.autoplay = $slideshow.data('autoplay'));

    slickTheme.init({
      $element: $slideshow,
      parallax: $slideshow.data('parallax'),
      autoplay: autoplay,
      autoplaySpeed: $slideshow.data('autoplayspeed'),
      adaptHeight: $slideshow.data('adapt'),
      arrows: true
    });

    // remove header absolute display if slideshow is empty
    if (!$slideshow.hasClass('hero')) {
      $('.header-wrapper').removeClass(slickTheme.vars.heroHeaderClass);
    }
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      this.$slideshow.unslick();
    },

    onBlockSelect: function (evt) {
      var $slide = $('.slide--' + evt.detail.blockId);
      var slideIndex = $slide.attr('index');

      // Go to selected slide, pause autoplay
      this.$slideshow.slickGoTo(slideIndex);
      if (this.autoplay) {
        this.$slideshow.slickPause();
      }
    },

    onBlockDeselect: function () {
      if (
        this.autoplay &&
        !slickTheme.cache.$pauseButton.hasClass(slickTheme.vars.pausedClass)
      ) {
        this.$slideshow.slickPlay();
      }
    }
  }
);

theme.PasswordHeader = (function () {
  function PasswordHeader() {
    this.init();
  }

  PasswordHeader.prototype = _.assignIn({}, PasswordHeader.prototype, {
    init: function () {
      // $('.js-toggle-login-modal').magnificPopup({
      //   type: 'inline',
      //   mainClass: 'mfp-fade',
      //   closeOnBgClick: false,
      //   closeBtnInside: false,
      //   closeOnContentClick: false,
      //   tClose: password.strings.pageClose,
      //   removalDelay: 500,
      //   callbacks: {
      //     open: function () {
      //       window.setTimeout(function () {
      //         document.getElementById('password').focus();
      //       }, 50);
      //     },
      //     close: function () {
      //       window.setTimeout(function () {
      //         document.getElementById('email').focus();
      //       }, 50);
      //     }
      //   }
      // });
      // if ($('.storefront-password-form .errors').size()) {
      //   $('.js-toggle-login-modal').click();
      // }
    }
  });

  return PasswordHeader;
})();

theme.PasswordContent = (function () {
  function PasswordContent() {
    theme.styleTextLinks();
  }

  return PasswordContent;
})();

theme.ProductRecommendations = (function () {
  var selectors = {
    productCard: '[data-product-card]'
  };

  function ProductRecommendations(container) {
    this.$container = $(container);

    var self = this;
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      '/recommendations/products?&section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    $.get(recommendationsSectionUrl).then(function (section) {
      var recommendationsMarkup = $(section).html();
      if (recommendationsMarkup.trim() !== '') {
        self.$container.html(recommendationsMarkup);
        self.sendTrekkieEvent();
      }
    });
  }

  ProductRecommendations.prototype = _.assignIn(
    {},
    ProductRecommendations.prototype,
    {
      sendTrekkieEvent: function () {
        if (
          !window.ShopifyAnalytics ||
          !window.ShopifyAnalytics.lib ||
          !window.ShopifyAnalytics.lib.track
        ) {
          return;
        }

        var didPageJumpOccur =
          this.$container[0].getBoundingClientRect().top <= window.innerHeight;
        var numberOfRecommendationsDisplayed = this.$container.find(
          selectors.productCard
        ).length;

        window.ShopifyAnalytics.lib.track('Product Recommendations Displayed', {
          theme: 'brooklyn',
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberOfRecommendationsDisplayed
        });
      }
    }
  );

  return ProductRecommendations;
})();

theme.Search = (function () {
  function Search() {
    theme.equalHeights();
  }

  return Search;
})();

theme.ProductShowcase = (function() {
  var selectors = {
    track: '[data-track]'
  }
  
  var POSITION_START = 0.1
  var POSITION_END = 0.9

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  function ProductShowcase(container) {
    this.$container = $(container);

    this.isAnimating = false

    this.$track = $(selectors.track, this.$container)
    this.track = this.$track.get(0)    
    this.$trackItems = this.$track.children()
    this.$jumpNext = $('[data-jump-next]', this.$container)
    this.$jumpPrev = $('[data-jump-prev]', this.$container)

    this.$track.on('scroll', this.onTrackScroll.bind(this))
    this.$jumpNext.on('click', e => this.onJumpClick(e, 1))
    this.$jumpPrev.on('click', e => this.onJumpClick(e, -1))

    this.onTrackScroll() // Trigger this to set vars    
  }

  ProductShowcase.prototype = _.assignIn({}, ProductShowcase.prototype, {
    animateScrollPosition(position) {      
      this.isAnimating = true 
  
      animateScrollTo([position, 0], {
        elementToScroll: this.track,
        speed: 600,
        minDuration: 500,
        maxDuration: 1500,
        easing: function(x) {
          return 1 - Math.pow(1 - x, 4)
        }
      }).then(() => {
        this.isAnimating = false
      })
    },
    
    
    onJumpClick: function(e, direction = 1) {
      e.preventDefault()

      if (this.isAnimating) return

      var scrollToPosition

      if (direction > 0) {
        // Jump forward by track width or space available, whichever is smaller
        var space = this.track.scrollWidth - this.track.scrollLeft
        var dist = Math.min(space, this.track.clientWidth)
        
        scrollToPosition = this.track.scrollLeft + dist
      }
      else {
        // Take the total amount of available space to scroll
        // Subtract the width of the the track and clamp to get how far we should move
        scrollToPosition = Math.max(this.track.scrollLeft - this.track.clientWidth, 0)
      }
  
      var scrollPercentage = scrollToPosition / (this.track.scrollWidth - this.track.clientWidth)
  
      // If we're within the start or end bounds, jump all the way
      if (scrollPercentage < POSITION_START) {
        scrollToPosition = 0
      }
      else if (scrollPercentage > POSITION_END) {
        scrollToPosition = this.track.scrollWidth + this.track.clientWidth
      }
  
      this.animateScrollPosition(scrollToPosition) 
    },

    onTrackScroll: function() {
      var progress = clamp(this.track.scrollLeft / (this.track.scrollWidth - this.track.clientWidth), 0, 1)
      var isStart = progress < POSITION_START
      var isEnd = progress > POSITION_END

      this.$jumpPrev.toggleClass('is-hidden', isStart)
      this.$jumpNext.toggleClass('is-hidden', isEnd)
    }
  })

  return ProductShowcase;
})();

theme.ProductShowcaseSection = (function() {
  function ProductShowcaseSection(container) {
    this.name = 'ProductShowcaseSection';
    this.$container = $(container);

    this.productShowcase = new theme.ProductShowcase(this.$container)
  }

  return ProductShowcaseSection;
}());

theme.ProductCollectionShowcaseSection = (function() {
  function ProductCollectionShowcaseSection(container) {
    this.name = 'ProductCollectionShowcaseSection';
    this.$container = $(container);

    this.productShowcase = new theme.ProductShowcase(this.$container)
  }

  return ProductCollectionShowcaseSection;
}());

theme.ShoppableProducts = (function () {
  function ShoppableProduct(el) {
    this.productGallery = new slate.ProductGallery($(el), {
      responsive: false
    });

    this.productForm = new slate.ProductForm($(el), {
      onColorSelectChange: this.onColorSelectChange.bind(this)
    });
  }

  ShoppableProduct.prototype = _.assignIn({}, ShoppableProduct.prototype, {
    onColorSelectChange: function (color) {
      this.productGallery.onColorSelectChange(color)
    },
    onUnload: function () {
      this.productForm.onUnload();
      this.productGallery.destroyImageCarousel();
    }
  });

  function ShoppableProductsSection(container) {
    this.$container = $(container);

    this.shoppableProducts = $.map($('[data-shoppable-product]', this.$container), function (el) { return new ShoppableProduct(el); });
  }

  ShoppableProductsSection.prototype = _.assignIn({}, ShoppableProductsSection.prototype, {
    onUnload: function () {
      $.each(this.shoppableProducts, function (i, sp) {
        sp.onUnload();
      });
    }
  });

  return ShoppableProductsSection;
})();

theme.LaunchProduct = (function () {
  function LaunchProduct(container) {
    this.$container = $(container);

    this.productGallery = new slate.ProductGallery(this.$container);

    this.productForm = new slate.ProductForm(this.$container, {
      onColorSelectChange: this.onColorSelectChange.bind(this)
    });
  }

  LaunchProduct.prototype = _.assignIn({}, LaunchProduct.prototype, {
    onColorSelectChange: function (color) {
      this.productGallery.onColorSelectChange(color)
    },

    onUnload: function () {
      this.productForm.onUnload();
      this.productGallery.destroyImageCarousel();
    }
  });

  return LaunchProduct;
})();

theme.variables = {
  productPageLoad: false,
  productPageSticky: true,

  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  mediaQuerySmall: 'screen and (max-width: 590px)',
  mediaQuerySmallZOR: 'screen and (max-width: 991px)',
  mediaQueryMedium: 'screen and (min-width: 591px) and (max-width: 768px)',
  mediaQueryMediumUp: 'screen and (min-width: 591px)',
  mediaQueryLarge: 'screen and (min-width: 769px)',
  bpSmall: false
};

theme._cacheInitFlag = false;
theme.initCache = function () {
  if (theme._cacheInitFlag) return;
  theme._cacheInitFlag = true;

  theme.cache = {
    $window: $(window),
    $html: $('html'),
    $body: $('body'),
    $drawerRight: $('.drawer--right'),

    $hero: $('#Hero'),
    $customSelect: $('.js-selector'),

    $collectionImage: $('.collection-hero__image'),

    $siteHeader: $('.site-header'),
    $siteNav: $('.site-nav'),
    $siteNavOpen: $('.site-nav--open'),
    $logoWrapper: $('.site-header__logo'),
    $logo: $('.site-header__logo img'),
    $searchBox: $('.site-nav--search__bar'),

    $productImages: $('.product-single__photos'),
    $productImagePhoto: $('.product-single__photo'),

    $indentedRteImages: $('.rte--indented-images'),

    $productGridRows: $('.collage-grid__row'),
    $productGridPhotosLarge: $('.grid__item--large .grid-product__image-link'),

    // Equal height elements
    $productGridImages: $('.grid-uniform .grid-product__image-wrapper'),

    $returnLink: $('.return-link')
  };
};

// Wrapper around HystModal
theme.initModals = function() {
  function Modals() {
    this.hystModal = new HystModal({
      linkAttributeName: 'data-hystmodal',
      waitTransitions: true,
      beforeOpen: function(modal) {
        window.dispatchEvent(new CustomEvent('hystmodal:beforeOpen', { bubbles: true, detail: { element: modal.element } }));
      },
      afterClose: function(modal) {
        window.dispatchEvent(new CustomEvent('hystmodal:afterClose', { bubbles: true, detail: { element: modal.element } }));
      }
    });
  }

  Modals.prototype = _.assignIn({}, Modals.prototype, {
    getOpenModal: function() {
      return this.hystModal.openedModals[0]?.element
    },

    open: function(selector) {
      this.hystModal.open(selector)
    },

    close: function() {
      this.hystModal.close()
    }
  })

  theme.modals = new Modals()
}

theme.init = function () {
  theme.initCache();
  theme.setBreakpoints();
  theme.fitNav();
  theme.cartInit();
  theme.checkoutIndicator();
  theme.returnLink();
  theme.styleTextLinks();
  theme.productCardImageLoadingAnimation();
  theme.ambientVideos();
  theme.initModals()

  // Functions to run on load so image sizes can be calculated
  theme.cache.$window.on('load', theme.resizeLogo);
  theme.cache.$window.on('load', theme.articleImages);

  // Functions to re-run on resize
  theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));
};

theme.returnLink = function () {
  if (!document.referrer || !theme.cache.$returnLink.length || !window.history.length) {
    return;
  }

  theme.cache.$returnLink.on('click', theme.backButton);
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.hostname;
  }
};

theme.setBreakpoints = function () {
  enquire.register(theme.variables.mediaQuerySmall, {
    match: function () {
      if (theme.settings.gridType === 'collage') {
        theme.clearCollageGridHeights();
      }

      theme.variables.bpSmall = true;
    },
    unmatch: function () {
      theme.variables.bpSmall = false;
    }
  });

};

theme.fitNav = function () {

  theme.cache.$window.on('load', controlNav);
  theme.cache.$window.on('resize', theme.debounce(controlNav, 150));
  theme.cache.$siteNav.addClass('site-nav--init');
  theme.cache.$siteNavOpen.addClass('site-nav--init');

  controlNav();

  function controlNav() {

    if ($(window).width() < 1024) {
      theme.cache.$siteNav.addClass('site-nav--compress');
      theme.cache.$siteNav.parent().addClass('visually-hidden');
      theme.cache.$siteNavOpen.addClass('site-nav--open__display');
      theme.cache.$siteNavOpen.parent().removeClass('large--hide');
      //theme.cache.$logoWrapper.parent().removeClass('large--one-third').addClass('large--two-thirds');
      theme.cache.$logoWrapper.removeClass('large--left').addClass('text-center');
      theme.cache.$searchBox.hide();
    } else {
      theme.cache.$siteNav.removeClass('site-nav--compress');
      theme.cache.$siteNav.parent().removeClass('visually-hidden');
      theme.cache.$siteNavOpen.removeClass('site-nav--open__display');
      theme.cache.$siteNavOpen.parent().addClass('large--hide');
      //theme.cache.$logoWrapper.parent().addClass('large--one-third').removeClass('large--two-thirds');
      theme.cache.$logoWrapper.addClass('large--left').removeClass('text-center');
      theme.cache.$searchBox.show();
    }

  }


  /*
  / Measure children of site nav on load and resize.
  // If wider than parent, switch to mobile nav.
  controlNav();
  theme.cache.$window.on('load', controlNav);
  theme.cache.$window.on('resize', theme.debounce(controlNav, 150));

  function controlNav() {
    // Subtract 20 from width to account for inline-block spacing
    var navWidth = theme.cache.$siteNav.parent().outerWidth() - 20;
    var navItemWidth = 0;
    theme.cache.$siteNav.find('> li').each(function() {
      var $el = $(this);
      // Round up to be safe
      navItemWidth += Math.ceil($(this).width());
    });

    if (navItemWidth > navWidth) {
      theme.cache.$siteNav.addClass('site-nav--compress');
      theme.cache.$siteNav.parent().removeClass('large--two-thirds').addClass('large--one-sixth');
      theme.cache.$siteNavOpen.addClass('site-nav--open__display');
      theme.cache.$siteNavOpen.parent().removeClass('large--hide');
      theme.cache.$logoWrapper.parent().removeClass('large--one-third').addClass('large--two-thirds');
      theme.cache.$logoWrapper.removeClass('large--left').addClass('text-center');
      theme.cache.$searchBox.hide();
    } else {
      theme.cache.$siteNav.removeClass('site-nav--compress');
      theme.cache.$siteNavOpen.removeClass('site-nav--open__display');
      theme.cache.$siteNavOpen.parent().addClass('large--hide');
      theme.cache.$searchBox.show();
    }

    theme.cache.$siteNav.addClass('site-nav--init');
    theme.cache.$siteNavOpen.addClass('site-nav--init');
  }
  */
};

theme.resizeLogo = function () {
  // Using .each() as there can be a reversed logo too
  theme.cache.$logo.each(function () {
    var $el = $(this),
      logoWidthOnScreen = $el.width(),
      containerWidth = $el.closest('.grid__item').width();
    // If image exceeds container, let's make it smaller
    if (logoWidthOnScreen > containerWidth) {
      $el.css('maxWidth', containerWidth);
    }
    else {
      $el.removeAttr('style');
    }
  });
};

theme.checkoutIndicator = function () {
  // Add a loading indicator on the cart checkout button (/cart and drawer)
  theme.cache.$body.on('click', '.cart__checkout', function () {
    $(this).addClass('btn--loading');
  });
};

theme.clearCollageGridHeights = function () {
  if (!theme.cache.$productGridRows.length) {
    return;
  };

  theme.cache.$productGridPhotosLarge.removeAttr('style');
};

theme.articleImages = function () {
  if (!theme.cache.$indentedRteImages.length) {
    return;
  }

  theme.cache.$indentedRteImages.find('img').each(function () {
    var $el = $(this);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr == 'float: none;') {
      // Remove grid-breaking styles if image isn't wider than parent
      if ($el.width() < theme.cache.$indentedRteImages.width()) {
        $el.addClass('rte__no-indent');
      }
    }
  });
};

theme.styleTextLinks = function () {
  $('.rte').find('a:not(:has(img))').addClass('text-link');
};

theme.equalHeights = function () {
  var self = this;
  theme.cache.$window.on('load', resizeElements());

  theme.cache.$window.on(
    'resize',
    afterResize(
      function () {
        resizeElements();
      },
      250,
      'equal-heights'
    )
  );

  function resizeElements() {
    self.cache.$productGridImages.css('height', 'auto').equalHeights();
  }
};

theme.cartInit = function () {
  if (!theme.cookiesEnabled()) {
    theme.cache.$body.addClass('cart--no-cookies');
  }
};

theme.cookiesEnabled = function () {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
}

theme.productCardImageLoadingAnimation = function () {
  var selectors = {
    image: '[data-image]',
    imageLink: '[data-image-link]',
  };

  var classes = {
    loadingAnimation: 'grid-product__image-link--loading',
    lazyloaded: '.lazyloaded'
  }

  $(document).on('lazyloaded', function (e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageLink)
      .removeClass(classes.loadingAnimation);
  });


  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  $(selectors.image + classes.lazyloaded)
    .closest(selectors.imageLink)
    .removeClass(classes.loadingAnimation);
}

// Wait for ambient videos to start playing and then display them
theme.ambientVideos = function () {
  $('video.ambient-video').each(function (i, video) {
    var $vid = $(video);
    $vid.one('play', $vid.addClass.bind($vid, 'is-playing'));

    setTimeout(function () {
      const p = video.play(); // in case autoplay didn't work
      p && p.catch(function (e) { console.log(e); }); // eslint-disable-line
    }, 1000);
  });
}

$(function () {
  theme.init();

  var sections = new theme.Sections();

  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('header-section', theme.HeaderSection);
  sections.register('footer-section', theme.FooterSection);
  sections.register('cart-drawer', theme.CartDrawer);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('shoppable-products', theme.ShoppableProducts);
  sections.register('launch-product', theme.LaunchProduct);
  sections.register('newsletter-section', theme.NewsletterSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('password-header', theme.PasswordHeader);
  sections.register('password-content', theme.PasswordContent);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('search', theme.Search);
  sections.register('product-showcase', theme.ProductShowcaseSection);
  sections.register('product-collection-showcase', theme.ProductCollectionShowcaseSection);
  sections.register('subscribe-popup', theme.SubscribePopupSection);

  console.log('%c Undefeated ', 'font-family: Helvetica; font-size: 26px; color: #000; background-color: #FFF; font-weight: bold; font-style: italic; text-transform: uppercase;');
  console.log('%c Development support → Stefan Bowerman - https://stefanbowerman.com ', 'font-family: Helvetica; font-size: 13px; color: #000; background-color: #FFF;');
});

/*
 * Run function after window resize
 * http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
 */
var afterResize = (function () {
  var t = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (t[uniqueId]) {
      clearTimeout(t[uniqueId]);
    }
    t[uniqueId] = setTimeout(callback, ms);
  };
})();


/*Open External Links in New Tabs*/
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
    links[i].setAttribute('aria-label', 'Link opens in a new window')
  }
}

/*A11y stuff*/
/**
 * For use when focus shifts to a container rather than a link
 * eg for In-page links, after scroll, focus shifts to content area so that
 * next `tab` is where user expects if focusing a link, just $link.focus();
 *
 * @param {jQuery} $element - The element to be acted upon
 */
function pageLinkFocus($element) {
  const focusClass = 'js-focus-hidden';

  function callback() {
    $element.first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
  }

  $element.first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);
}

$('.in-page-link').on('click', evt => pageLinkFocus($(evt.currentTarget.hash)));

// SEARCH AUTOCOMPLETE
// This used to live in a snippet included in the layout
$(function() {
  var RESULTS_LIMIT = 10;
  var MIN_CHAR_COUNT = 2;

  var $searchWrappa = $('.search-bar-wrappa');
  var $input = $searchWrappa.find('input[name="q"]');
  var $bananaSearch = $('#banana_Search');
  var $prodResults = $bananaSearch.find('#product-search-results');
  var $productsNumber = $bananaSearch.find('.products_number');

  var currentProdRequest = null;

  // Save previous search term
  var oldTermProduct = null;

  $input.attr('autocomplete', 'off');

  function isActive() {
    return $bananaSearch.hasClass('active')
  }

  function activateDropdown() {
    if (isActive()) return;

    $bananaSearch.slideDown({
      duration: 375,
      easing: 'easeInOutCubic',
      start: function () {
        $searchWrappa.addClass('active');
        $bananaSearch.addClass('active');   
      }      
    })    
  }

  function deactivateDropdown() {
    if (!isActive()) return;

    $bananaSearch.slideUp({
      duration: 400,
      easing: 'easeOutCubic',
      complete: function() {
        $searchWrappa.removeClass('active');
        $bananaSearch.removeClass('active');
      }
    });
  }

  $(document).on('click', function(e) {
    var noRedirect = '.search-bar-wrappa form input, #banana_Search, .search-results-wrapper, .search-results-wrapper > *, .view-all-search-prod, .view-all-search-prod > *';

    if (e.target.matches(noRedirect) === false) {
      deactivateDropdown()
    }
  });  

  // Listening to keyup and change on the text field within these search forms.
  $input.on('keyup change', function() {
    var term = $(this).val();

    if (term && term.length >= MIN_CHAR_COUNT) {
      prodSearch(term);
      // restSearch(term);
    }
    else {
      resetSearch()     
    }
  });  

  $input
    .on('click focus', activateDropdown)
    .on('blur', function() {
      var term = $(this).val()

      if (!term) {
        deactivateDropdown()
      }
    });

  function formatResultLink(item) {
    return [
      '<li class="search-results-list__item">',
        '<a href="' + item.url + '">',
          item.title,
        '</a>',
      '</li>'
    ].join('')
  }

  function resetSearch() {
    oldTermProduct = null
    $prodResults.empty()
    $productsNumber.text(0)
  }
    
  function prodSearch(termProduct) {
    var baseUrl = '/search?type=product&q=' + termProduct;
    var $resultsList = $('<ul class="search-results-list"></ul>');

    // Make sure there's a new term that contains at least 3 characters.
    if (termProduct.length < MIN_CHAR_COUNT || termProduct === oldTermProduct) {
      return;
    }
      
    // Killing any Ajax request that's currently being processed.
    if (currentProdRequest != null) currentProdRequest.abort();
    
    // Saving old query.
    oldTermProduct = termProduct
    
    // Pulling results.
    currentProdRequest = $.getJSON(baseUrl + '&view=json',  function(data) {
      $.each(data.results, function(index, item) {
        $resultsList.append(formatResultLink(item))

        if (index+1 === RESULTS_LIMIT) {
          $resultsList.append(formatResultLink({
            url: '/search?q='+termProduct,
            title: '... (View All)'
          }))            
        }
      });

      $prodResults.empty().append($resultsList)
      $productsNumber.text(data.results_count);
    });
  };
});